import React, { useEffect, useState, useRef, useCallback } from "react";
import makeAnimated from 'react-select/animated';
import CreatableSelect from 'react-select/creatable';
import { Link, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import moment from "moment";
import { uploadexcelforest, updateCustomerforest, deleteCustomerforest, createCustomerforestView, fetchCustomersById, startScan, getScanSchedule, scheduleScan } from "../../actions/customer";
import { IMAGE_URL, API_URL } from "../../utils/constant";
import { emailSuggestion } from "../../actions/riskManagement";
import $ from "jquery";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp, faSortDown, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import Pagination from "../Pagination/Pagination";
import {
    fetchCustomersforestView
} from "../../actions/customer";
import { format, isValid } from "date-fns";
import axios from "axios";
import debounce from "lodash/debounce";
// import { viewCertificate } from "../../actions/riskManagement";

const fileUrl = '../../assets/excel/Vendor-bulk-upload.xlsx';

// Custom styles for scan scheduling
const labelClassStyle = {
    margin: "0 15px 0 0",
    display: "inline-flex",
    alignItems: "center"
};

const radioButtonStyle = {
    marginRight: "5px"
};

// Add these styles inside your component or in your CSS file
const sliderStyles = `
.profiling-questions-slider {
    background-color: #f8f9fa;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.question-slide {
    min-height: 200px;
    padding: 15px;
    background-color: white;
    border-radius: 5px;
    border: 1px solid #e0e0e0;
}

.slider-progress {
    font-weight: 500;
    color: #666;
    padding: 5px 10px;
    background-color: #e9ecef;
    border-radius: 20px;
}

/* Tabbed interface styles */
.nav-tabs .nav-link {
    color: #495057;
    background-color: #f8f9fa;
    border-color: #dee2e6 #dee2e6 #fff;
    font-weight: 500;
}

.nav-tabs .nav-link.active {
    color: #007bff;
    background-color: #fff;
    border-color: #dee2e6 #dee2e6 #fff;
    border-bottom: 2px solid #007bff;
}

.tab-pane {
    padding: 20px 15px;
}

.question-item {
    background-color: #fff;
    border-radius: 4px;
    transition: all 0.2s;
}


.profiling-questions-container::-webkit-scrollbar {
    width: 8px;
}

.profiling-questions-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.profiling-questions-container::-webkit-scrollbar-thumb {
    background: #d1d1d1;
    border-radius: 4px;
}

.profiling-questions-container::-webkit-scrollbar-thumb:hover {
    background: #c1c1c1;
}

.action-buttons {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
}

.action-btn {
    min-width: 80px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    color: #6563ff;
    transition: all 0.2s ease;
    background: transparent;
    border: 1px solid #e0e0e0;
    text-decoration: none;
    padding: 0 8px;
    font-size: 12px;
    font-weight: 500;
}

.action-btn:hover {
    background: #f8f9fa;
    color: #4a47a7;
    text-decoration: none;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.action-btn.text-danger:hover {
    background: #fff5f5;
    color: #dc3545;
    border-color: #dc3545;
}

.action-btn.text-info:hover {
    background: #f0f9ff;
    color: #0dcaf0;
    border-color: #0dcaf0;
}

.action-btn.text-success:hover {
    background: #f0fff4;
    color: #28a745;
    border-color: #28a745;
}

.action-btn i {
    font-size: 12px;
    margin-right: 4px;
}

.action-label {
    font-size: 11px;
    font-weight: 500;
    white-space: nowrap;
}

/* Responsive design for smaller screens */
@media (max-width: 768px) {
    .action-buttons {
        gap: 4px;
    }
    
    .action-btn {
        min-width: 60px;
        height: 28px;
        font-size: 11px;
        padding: 0 6px;
    }
    
    .action-btn i {
        font-size: 11px;
        margin-right: 3px;
    }
    
    .action-label {
        font-size: 10px;
    }
}
`;

const animatedComponents = makeAnimated();
const VendorRisk = () => {
    const dispatch = useDispatch();
    const auth = useSelector((state) => state?.auth?.user)
    const [filterData, setfilterData] = useState("all");
    const { orgId } = useParams();
    const location = useLocation();
    const vendorName = sessionStorage.getItem('vendorName');
    // const vendorId = sessionStorage.getItem('vendorId');
    const [isEdit, setIsEdit] = useState(false);
    const [isModal, setModal] = useState("");
    const [refreshModal, setRefreshModal] = useState(false);
    const [totalItemsSearch, setTotalItemsSearch] = useState(0);
    const [selectedOrgId, setSelectedOrgId] = useState("");
    const [services, setServices] = useState([]);
    const [page, setPage] = useState(1);
    const [updateId, setUpdateId] = useState("");
    var date = new Date();
    date = moment(date).add(1, "year").toDate();
    const [expiredAt, selectDate] = useState(date);
    const [status, setStatus] = useState("all");
    const [firstLoad, setFirstLoad] = useState(true);
    const [PageSize, setPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [search, setSearch] = useState("");
    const [sortField, setSortField] = useState("");
    const [sortOrder, setSortOrder] = useState("");
    const [scanType, setscanType] = useState("No");
    const [scanScheduleDay, setscanScheduleDay] = useState("Sunday");
    const [orgName, setOrgName] = useState("");
    const [orgEmail, setOrgEmail] = useState("");
    const [orgContactName, setOrgContactName] = useState("");
    const [orgContact, setOrgContact] = useState("");
    const [website, setWebsite] = useState("");
    const [emailAccess, setEmailAccess] = useState(false);
    const [clientType, setClientType] = useState("1");
    const [plan, setPlan] = useState("basic");
    const [industryType, setindustryType] = useState("");
    const [domains, setDomain] = useState([]);
    const [authMethod, setAuthMethod] = useState("default");
    const [serverType, setServerType] = useState("");
    const [loginUrl, setLoginUrl] = useState("");
    const [logo, setLogo] = useState("");
    const [subscriptionType, setSubscriptionType] = useState("");
    const [address, setAddress] = useState("");
    const [country, setCountry] = useState("");
    const [state, setState] = useState("");
    const [city, setCity] = useState("");
    const [loginPage, setLoginPage] = useState("");
    const [facebookUrl, setFacebookUrl] = useState("");
    const [twitterUrl, setTwitterUrl] = useState("");
    const [linkedinUrl, setLinkedinUrl] = useState("");
    const [instagramUrl, setInstagramUrl] = useState("");
    const [keyWord, setKeyword] = useState("");
    const [isViewCertificateModal, setIsViewCertificateModal] = useState(false);
    const [criticality, setCriticality] = useState("Medium");
    const [tags, setTags] = useState([]);
    const [tagInput, setTagInput] = useState("");
    const [isScheduleScanModal, setIsScheduleScanModal] = useState(false);
    const [attackSurfaceScan, setAttackSurfaceScan] = useState(true);
    const [darkWebScan, setDarkWebScan] = useState(true);
    const [enableSchedule, setEnableSchedule] = useState(false);
    const [modalVendorName, setModalVendorName] = useState("");
    const [modalVendorId, setModalVendorId] = useState("");
    const [criticalityFilter, setCriticalityFilter] = useState("");
    const [tagsFilter, setTagsFilter] = useState("");
    const emailData = useSelector((state) => state?.riskManagement?.emailSuggestion);
    const [serviceProfileData, setServiceProfileData] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [emails, setEmails] = useState([]);
    const [emailQuery, setEmailQuery] = useState('');
    const [dueDate, setDueDate] = useState('');
    const [showQuestionnaireForm, setShowQuestionnaireForm] = useState(false);
    const org = JSON.parse(localStorage.getItem("org") || "{}");

    // Add these state variables at the top with your other state variables
    const [isDomainInUse, setIsDomainInUse] = useState(false);
    const [moduleLicenses, setModuleLicenses] = useState({
        tprm_questionaire: true,
        tprm_risk_assesment: true
    });

    const [certificateData, setCertificateData] = useState({
        name: "",
        description: "",
        type: "",
        validating: "",
        policy: {
            isExpired: false,
            expiryDate: "",
            startDate: "",
            endDate: "",
            noExpiry: false,
            documentType: ""
        },
        fileUrl: "",
        fileName: ""
    });
    const isMSSP = JSON.parse(localStorage.getItem("user")).accessLevel === "MSSP";
    const dropdownRefs = useRef({});
    let forestViewList = useSelector(
        (state) => state?.customer?.forestlist?.data
    );

    const id = useSelector(state => {
        return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    });

    const [profilingQuestions, setProfilingQuestions] = useState([]);

    // Add these state variables for vendor profiling
    const [vendorProfiling, setVendorProfiling] = useState([]);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [showProfilingQuestions, setShowProfilingQuestions] = useState(false);
    const [profilingComplete, setProfilingComplete] = useState(false);

    // Add these state variables
    const [currentStep, setCurrentStep] = useState(1); // 1: Basic info, 2: Profiling, 3: Questionnaire

    // Get scan schedule data from Redux store
    const scanScheduleReduxData = useSelector(state => state?.customer?.scanSchedule?.data);
    // Update local state when Redux data changes

    const [scanScheduleData, setScanScheduleData] = useState(null);
    const [scanScheduleLoading, setScanScheduleLoading] = useState(false);
    const [scanFrequency, setScanFrequency] = useState({
        attackSurface: "daily",
        darkWeb: "daily"
    });

    const [brandDetails, setBrandDetails] = useState(null);
    const [loadingBrand, setLoadingBrand] = useState(false);

    // Add new state for industries
    const [industries, setIndustries] = useState([]);

    const [isEditServiceProfileModal, setIsEditServiceProfileModal] = useState(false);
    const [editingDomains, setEditingDomains] = useState([]);
    const [editingTier, setEditingTier] = useState("");

    // 1. Remove the hardcoded availableDomains useState and add dynamic state
    const [availableDomains, setAvailableDomains] = useState([]);

    // 2. Fetch available domains from API on mount
    useEffect(() => {
      const fetchAvailableDomains = async () => {
        try {
          const session = localStorage.getItem("session");
          const response = await axios.get(`${API_URL}/tprm/vendor-profiling/question-domains`, {
            headers: { Authorization: `Bearer ${session}` }
          });
          if (response.data && response.data.data) {
            setAvailableDomains(response.data.data);
          } else {
            setAvailableDomains([]);
          }
        } catch (error) {
          setAvailableDomains([]);
        }
      };
      fetchAvailableDomains();
    }, []);

    useEffect(() => {
        // Check if URL has #add-vendor or ?modal=add-vendor
        if (location.hash === '#add-vendor' || new URLSearchParams(location.search).get('modal') === 'add-vendor') {
            setModal("Form Wizard modal");
        }
    }, [location]);
    
    // First add these new state variables at the top with your other state variables
    const [serviceName, setServiceName] = useState("");
    const [serviceRegion, setServiceRegion] = useState("");
    const [isCheckingService, setIsCheckingService] = useState(false);
    const [serviceExists, setServiceExists] = useState(false);
    const [existingServiceData, setExistingServiceData] = useState(null);

    // Add these new variables and functions at the top of your component

    // First add missing state variables
    const [blank, setblank] = useState(null);
    const fileInputRef = useRef(null);

    // Add missing functions
    const handleFileSelect = (event) => {
        // Add file selection logic here
        const file = event.target.files[0];
        if (file) {
            // Process the selected file
            const formData = new FormData();
            formData.append("excelFile", file);
            uploadexcelforest(formData, id, dispatch)
            setblank('');
            setSelectedFile(null);
            // You might want to store the file in state
        }
    };

    const handleFileUpload = () => {
        
        if (selectedFile) {
          const formData = new FormData();
          formData.append("excelFile", selectedFile);
          uploadexcelforest(formData, id, dispatch)
          setblank('');
          setSelectedFile(null);
        } else {
          // If no file is selected, trigger file input click
          fileInputRef.current.click();
        }
      };

    const formatScore = (score, maxScore) => {
        if (score === null || score === undefined || isNaN(score)) {
            return <span className="text-muted">N/A</span>;
        }

        const numericScore = parseFloat(score);
        let badgeClass = "badge-success";

        if (maxScore) {
            const percentage = (numericScore / maxScore) * 100;
            if (percentage > 70) {
                badgeClass = "badge-danger";
            } else if (percentage > 40) {
                badgeClass = "badge-warning";
            }
        } else {
            if (numericScore > 70) {
                badgeClass = "badge-danger";
            } else if (numericScore > 40) {
                badgeClass = "badge-warning";
            }
        }

        return <span className={`badge ${badgeClass}`}>{numericScore.toFixed(2)}</span>;
    };

    const handleScanFrequencyChange = (scanType, frequency) => {
        setScanFrequency(prev => ({
            ...prev,
            [scanType]: frequency
        }));
    };

    const submitScanSchedule = async () => {
        try {
            if (!modalVendorId) {
                toastr.error("Error", "No vendor selected for scan scheduling");
                return;
            }

            // Prepare the data
            const scheduleData = {
                attackSurface: attackSurfaceScan ? scanFrequency.attackSurface : "no",
                dataExposure: darkWebScan ? scanFrequency.darkWeb : "no",
            };

            // Call the scheduleScan action
            await scheduleScan(id, modalVendorId, scheduleData, dispatch);

            // Show success message
            toastr.success("Success", "Scan schedule updated successfully");

            // Close the modal
            setIsScheduleScanModal(false);
        } catch (error) {
            // console.error removed
            toastr.error("Error", "Failed to update scan schedule");
        }
    };


    useEffect(() => {
        if (id) {
            emailSuggestion(id, dispatch, isDomainInUse ? conflictingVendorId : createdVendorId, "");
        }
    }, [id, "", ""])

    useEffect(() => {
        const fetchIndustries = async () => {
            try {
                const session = localStorage.getItem("session");
                const response = await axios.get(
                    `${API_URL}/utils/industries`,
                    {
                        headers: {
                            Authorization: `Bearer ${session}`
                        }
                    }
                );
                if (response.data.error === false) {
                    setIndustries(response.data.data || []);
                }
            } catch (error) {
                // console.error removed
            }
        };

        fetchIndustries();
    }, []);

    // Fix the fetchBrandDetails function
    const fetchBrandDetails = async (domain) => {
        try {
            if (!domain || typeof domain !== 'string' || domain.trim() === '') {
                // console.error removed
                return;
            }

            setLoadingBrand(true);
            const session = localStorage.getItem("session");

            const response = await axios.get(
                `${API_URL}/tprm/brand-details/${encodeURIComponent(domain)}`,
                {
                    headers: {
                        Authorization: `Bearer ${session}`
                    }
                }
            );

            if (response.data && response.data.error === false) {
                const data = response.data.data;
                setBrandDetails(data);

                // Auto-fill form fields with brand details
                if (data.orgName) setOrgName(data.orgName);


                // Find matching industry from the industries list
                if (data.industry && industries.length > 0) {
                    const matchingIndustry = industries.find(ind =>
                        ind.toLowerCase() === data.industry.toLowerCase()
                    );

                    if (matchingIndustry) {
                        setindustryType(matchingIndustry);
                    } else {
                        // If no exact match, try partial match
                        const partialMatch = industries.find(ind =>
                            ind.toLowerCase().includes(data.industry.toLowerCase()) ||
                            data.industry.toLowerCase().includes(ind.toLowerCase())
                        );
                        setindustryType(partialMatch || data.industry);
                    }
                }

                if (data.address) setAddress(data.address);

                // Add domain to domains array if not already present
                if (!domains.includes(domain)) {
                    setDomain([...domains, domain]);
                }

                toastr.success("Success", "Brand details retrieved successfully");
            } else {
                // console.warn removed
                toastr.warning("Warning", response.data?.userMessage || "No brand details found for this domain");
            }
        } catch (error) {
            // console.error removed
            toastr.error("Error", error.response?.data?.userMessage || "Failed to fetch brand details");
        } finally {
            setLoadingBrand(false);
        }
    };

    useEffect(() => {
        if (id) {
            fetchCustomersforestView(id, dispatch, page, search, sortField, sortOrder, tagsFilter, criticalityFilter);
        }
    }, [id, page, search, sortField, sortOrder, tagsFilter, criticalityFilter]);

    // Add effect to fetch scan schedule
    useEffect(() => {
        if (id) {
            getScanSchedule(id, dispatch);
        }
    }, [id]);

    useEffect(() => {
        setScanScheduleData(scanScheduleReduxData);
        setScanScheduleLoading(false);

        if (scanScheduleReduxData) {

            // Handle the flat structure format we see in the console
            setAttackSurfaceScan(scanScheduleReduxData.attackSurface !== "no");
            setDarkWebScan(scanScheduleReduxData.dataExposure !== "no");

            setScanFrequency({
                attackSurface: scanScheduleReduxData.attackSurface === "no" ? "daily" : scanScheduleReduxData.attackSurface,
                darkWeb: scanScheduleReduxData.dataExposure === "no" ? "daily" : scanScheduleReduxData.dataExposure
            });
        }
    }, [scanScheduleReduxData]);

    useEffect(() => {
        setTotalItemsSearch(forestViewList?.totalForestViewClients)
    }, [forestViewList?.totalForestViewClients])

    // Add this useEffect to fetch vendor profiling questions
    useEffect(() => {
        const fetchVendorProfilingQuestions = async () => {
            try {
                const response = await axios.get(`${API_URL}/tprm/vendor-profiling/questions`);
                if (response.data && !response.data.error) {
                    setProfilingQuestions(response.data.data || []);
                } else {
                    toastr.error("Error", "Failed to load profiling questions");
                }
            } catch (error) {
                toastr.error("Error", "Failed to load profiling questions");
            }
        };

        fetchVendorProfilingQuestions();
    }, []);

    let mapDataForest = forestViewList?.forestViewClients;
    let currentTableDataForest = [];
    currentTableDataForest = mapDataForest;

    const addModal = () => {
        // Reset all form fields to default values
        setIsEdit(false);
        setOrgName("");
        setOrgEmail("");
        setOrgContact("");
        setOrgContactName("");
        setWebsite("");
        setEmailAccess(false);
        // client type removed
        // plan removed
        setindustryType("");
        setDomain([]);
        setAuthMethod("default");
        setServerType("");
        setLoginUrl("");
        setLogo("");
        // subscription type removed
        setAddress("");
        setCountry("");
        setState("");
        setCity("");
        setLoginPage("");
        // Social media URLs removed
        setKeyword([]);
        setCriticality("Medium");
        setTags([]);
        setTagInput("");

        // License duration removed

        // Continuous monitoring removed
        setModuleLicenses({
            tprm_questionaire: true,
            tprm_risk_assesment: true
        });

        // Reset profiling questions state
        setVendorProfiling([]);
        setCurrentQuestionIndex(0);
        setShowProfilingQuestions(false);
        setProfilingComplete(false);

        // Open the modal
        setModal("Form Wizard modal");
    };

    const handleProfilingAnswer = (answer) => {
        if (!profilingQuestions[currentQuestionIndex]) {
            // console.error removed
            return;
        }

        const updatedProfiling = [...vendorProfiling];

        // Create or update the answer for current question
        updatedProfiling[currentQuestionIndex] = {
            questionId: `question_${currentQuestionIndex}`,
            question: profilingQuestions[currentQuestionIndex]?.question || 'Unknown question',
            type: profilingQuestions[currentQuestionIndex]?.type,
            response: answer || ''
        };
        setVendorProfiling(updatedProfiling);

        // Move to next question or complete if all questions answered
        if (currentQuestionIndex < profilingQuestions.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        } else {
            setProfilingComplete(true);
            setShowProfilingQuestions(false);
        }
    };

    const startProfiling = () => {
        // Basic validation before starting the profiling
        if (!orgName.trim()) {
            toastr.error("Error", "Organization name is required before proceeding");
            return;
        }
        if (!industryType) {
            toastr.error("Error", "Industry type is required before proceeding");
            return;
        }

        // Initialize empty answers for all questions
        const initialProfiling = profilingQuestions.map((question, index) => ({
            questionId: `question_${index}`,
            question: question.question || 'Unknown question',
            type: question.type,
            options: question.options || [],
            response: ''
        }));

        setVendorProfiling(initialProfiling);
        setCurrentQuestionIndex(0);
        setShowProfilingQuestions(true);
    };

    const goToProfilingStep = () => {
        // Basic validation before moving to next step
        if (!orgName.trim()) {
            toastr.error("Error", "Organization name is required before proceeding");
            return;
        }
        if (!industryType) {
            toastr.error("Error", "Industry type is required before proceeding");
            return;
        }
        
        // Move to profiling step
        setCurrentStep(2);
    };

    // Add new state for similar questionnaire data
    const [similarQuestionnaire, setSimilarQuestionnaire] = useState(null);

    const checkSimilarQuestionnaires = async () => {
        try {
            const session = localStorage.getItem("session");
            
            // Determine the correct vendor ID to use
            const vendorId = isDomainInUse ? 
                conflictingVendorId : // Use existing vendor ID if domain is in use
                createdVendorId;     // Use newly created vendor ID otherwise
            
            if (!vendorId) {
                return;
            }

            const checkSimilarResponse = await axios.get(
                `${API_URL}/tprm/${id}/vendors/${vendorId}/service-profiles/${serviceProfileData._id}/check-similar`,
                {
                    headers: {
                        Authorization: `Bearer ${session}`
                    }
                }
            );

            if (checkSimilarResponse.data.error === false && checkSimilarResponse.data.data) {
                setSimilarQuestionnaire(checkSimilarResponse.data.data);
            } else {
                setSimilarQuestionnaire(null);
            }
        } catch (error) {
            // console.error removed
            setSimilarQuestionnaire(null);
        }
    };

    // Add useEffect to check for similar questionnaires when step 3 is shown
    useEffect(() => {
        if (currentStep === 3) {
            checkSimilarQuestionnaires();
        }
    }, [currentStep]);

    const sendQuestionnaire = async () => {
        if (emails.length === 0) {
            toastr.error("Error", "Please add at least one email address");
            return;
        }

        try {
            const session = localStorage.getItem("session");
            
            // Determine the correct vendor ID to use
            const vendorId = isDomainInUse ? 
                conflictingVendorId : // Use existing vendor ID if domain is in use
                createdVendorId;     // Use newly created vendor ID otherwise
            
            if (!vendorId) {
                toastr.error("Error", "Could not determine vendor ID for sending questionnaire");
                return;
            }
            
            // Proceed with sending the questionnaire
            const response = await axios.post(
                `${API_URL}/organisations/${id}/tprm/questioner/send-default`,
                {
                    _id: vendorId,
                    emails: emails,
                    serviceProfileId: serviceProfileData._id
                },
                {
                    headers: {
                        Authorization: `Bearer ${session}`
                    }
                }
            );

            if (response.data.error === false) {
                toastr.success("Success", "Questionnaire sent successfully");
                // Close modal and reset form
                resetFormFields();
                setModal("");
            } else {
                toastr.error("Error", response.data.userMessage || "Failed to send questionnaire");
            }
        } catch (error) {
            // console.error removed
            toastr.error("Error", error.response?.data?.userMessage || "Failed to send questionnaire");
        }
    };

    let clientTypeData = [];
    if (JSON.parse(localStorage.getItem("user")).accessLevel === "MSSP")
        clientTypeData = [{ id: 1, text: "Client" }];
    else
        clientTypeData = [
            { id: 1, text: "Client" },
            { id: 3, text: "MSSP" },
        ];

    let subscriptionTypeData = [];
    let subscriptionValueMSSP = [
        { val: "", text: "MSSP Subscription Type" },
        { val: "trial", text: "Trial" },
        { val: "regular", text: "Regular Client" },
    ];
    let subscriptionValueClient = [
        { val: "", text: "Subscription Type" },
        // {val: "trial", text: "Trial" },
        // {val: "one-time", text: "One time" },
        // {val: "gold", text: "Gold" },
        { val: "platinum", text: "Platinum" },
    ];
    if (JSON.parse(localStorage.getItem("user")).accessLevel === "MSSP") {
        if (
            JSON.parse(localStorage.getItem("user")).organisationId
                ?.subscriptionType === "trial"
        ) {
            subscriptionValueMSSP = [
                { val: "", text: "Subscription Type" },
                { val: "trial", text: "Trial" },
            ];
        } else {
            subscriptionValueMSSP = [
                { val: "", text: "Subscription Type" },
                // {val: "trial", text: "Trial" },
                // {val: "one-time", text: "One time" },
                // {val: "gold", text: "Gold" },
                { val: "platinum", text: "Platinum" },
            ];
        }
    }

    // Update the handleClick function for domain checking
    const [conflictingVendorId, setConflictingVendorId] = useState(null);

    const handleClick = async (field) => {
        if (field === "domain") {
            const domainInput = document.getElementById("domain");
            if (domainInput && domainInput.value) {
                try {
                    setLoadingBrand(true);

                    // Add domain to the list regardless of availability
                    const domainValue = domainInput.value.trim();

                    // First check if it's already in our local list
                    if (!domains.includes(domainValue)) {
                        setDomain([...domains, domainValue]);
                    }

                    // Check if domain is already in use in the system
                    const session = localStorage.getItem("session");
                    const response = await axios.get(
                        `${API_URL}/organisation/${id}/check-domain?domain=${domainValue}`,
                        {
                            headers: {
                                Authorization: `Bearer ${session}`
                            }
                        }
                    );

                    // Handle the API response format
                    if (response.data.error === false && response.data.data.isAvailable === true) {
                        // Domain is available
                        setIsDomainInUse(false);
                        setConflictingVendorId("0"); // Reset to '0' for non-conflicting domain
                        
                        // Show success message
                        toastr.success("Success", response.data.userMessage || "Domain is available for use");
                    } else {
                        // Domain is not available
                        setIsDomainInUse(true);
                        
                        // Store the vendor ID if available in the response
                        if (response.data.data && response.data.data.subOrganisationId) {
                            setConflictingVendorId(response.data.data.subOrganisationId);
                        }
                        
                        // Show warning message
                        toastr.warning("Domain Notice",
                            response.data.userMessage ||
                            `Domain '${domainValue}' is already registered in the system but has been added to your form`
                        );
                    }

                    await fetchBrandDetails(domainValue);

                    // Clear the input field
                    domainInput.value = "";

                } catch (error) {
                    // Handle error response
                    if (error.response && error.response.status === 409) {
                        // Domain is already in use
                        const data = error.response.data;
                        const domainValue = domainInput.value.trim();

                        // Set conflict state
                        setIsDomainInUse(true);

                        // Store the vendor ID if available in the response
                        if (data.data && data.data.vendorId) {
                            setConflictingVendorId(data.data.vendorId);
                        }

                        // Show warning message
                        toastr.warning("Domain Notice",
                            data.userMessage ||
                            `Domain '${data.data?.domain || domainValue}' is already registered in the system`
                        );
                    } else {
                        // console.error removed
                        setIsDomainInUse(false);
                        setConflictingVendorId(null);
                    }

                    // Clear the input field
                    domainInput.value = "";
                } finally {
                    setLoadingBrand(false);
                }
            }
        } else if (field === "twitter") {
            let val = $("#twitterUrl").val();
            let _keyWord = twitterUrl || [];
            if (_keyWord.indexOf(val) !== -1) {
                toastr.error("Error", "This keyword is already added.");
                return false;
            }
            $("#twitterUrl").val("");
            setTwitterUrl([..._keyWord, val]);
        } else if (field === "instagram") {
            let val = $("#instagramUrl").val();
            let _keyWord = instagramUrl || [];
            if (_keyWord.indexOf(val) !== -1) {
                toastr.error("Error", "This keyword is already added.");
                return false;
            }
            $("#instagramUrl").val("");
            setInstagramUrl([..._keyWord, val]);
        } else if (field === "tag") {
            let val = tagInput.trim();
            if (!val) return false;

            // Split the input by commas and spaces to handle multiple tags
            const newTags = val.split(/[,\s]+/).filter(tag => tag.trim() !== '');

            if (newTags.length === 0) return false;

            let _tags = [...(tags || [])];
            let addedCount = 0;

            // Process each tag
            newTags.forEach(tag => {
                const trimmedTag = tag.trim();
                if (trimmedTag && _tags.indexOf(trimmedTag) === -1) {
                    _tags.push(trimmedTag);
                    addedCount++;
                }
            });

            if (addedCount === 0) {
                toastr.error("Error", "All tags already exist");
                return false;
            }

            setTagInput("");
            setTags(_tags);
        }
    };

    const removeKeyword = (_id, _keyword) => {
        if (_id === "keyword") {
            let newkeyword = keyWord;
            newkeyword.splice(newkeyword.indexOf(_keyword), 1);
            setKeyword([...newkeyword]);
        } else if (_id === "facebook") {
            let newkeyword = facebookUrl;
            newkeyword.splice(newkeyword.indexOf(_keyword), 1);
            setFacebookUrl([...newkeyword]);
        } else if (_id === "linkedin") {
            let newkeyword = linkedinUrl;
            newkeyword.splice(newkeyword.indexOf(_keyword), 1);
            setLinkedinUrl([...newkeyword]);
        } else if (_id === "twitter") {
            let newkeyword = twitterUrl;
            newkeyword.splice(newkeyword.indexOf(_keyword), 1);
            setTwitterUrl([...newkeyword]);
        } else if (_id === "instagram") {
            let newkeyword = instagramUrl;
            newkeyword.splice(newkeyword.indexOf(_keyword), 1);
            setInstagramUrl([...newkeyword]);
        } else if (_id === "tag") {
            let newTags = [...tags];
            newTags.splice(newTags.indexOf(_keyword), 1);
            setTags(newTags);
        } else {
            let _domain = domains;
            _domain.splice(_domain.indexOf(_keyword), 1);
            setDomain([..._domain]);
        }
    };

    const editModal = (row) => {
        setUpdateId(row?._id);
        setIsEdit(true);

        // Find matching industry from the industries list
        if (row?.industryType) {
            const matchingIndustry = industries.find(ind =>
                ind.toLowerCase() === row.industryType.toLowerCase()
            );
            if (matchingIndustry) {
                setindustryType(matchingIndustry);
            } else {
                // If no exact match, try partial match
                const partialMatch = industries.find(ind =>
                    ind.toLowerCase().includes(row.industryType.toLowerCase()) ||
                    row.industryType.toLowerCase().includes(ind.toLowerCase())
                );
                setindustryType(partialMatch || row.industryType);
            }
        } else {
            setindustryType("");
        }

        setOrgName(row?.orgName);
        setOrgEmail(row?.orgEmail);
        setOrgContact(row?.orgContact);
        setWebsite(row?.website);
        setLoginPage(row?.loginPage);
        setEmailAccess(row?.emailAccess);
        setDomain(row?.domains);
        setAuthMethod(row?.authMethod);
        setLogo(row?.logo);
        setAddress(row?.address);
        setCountry(row?.country);
        setState(row?.state);
        setCity(row?.city);
        setKeyword(row?.keyWord);
        setOrgContactName(row?.orgContactName);
        setCriticality(row?.criticality || "Medium");
        setTags(row?.tags || []);
        setServerType(row?.serverType);
        setLoginUrl(row?.loginUrl);
        // Set module licenses if they exist in the vendor data
        if (row?.moduleLicenses && Array.isArray(row.moduleLicenses)) {
            const licenses = {};
            row.moduleLicenses.forEach(license => {
                licenses[license.name] = license.enabled;
            });
            setModuleLicenses({
                tprm_questionaire: licenses.tprm_questionaire || false,
                tprm_risk_assesment: licenses.tprm_risk_assesment || false
            });
        } else {
            setModuleLicenses({
                tprm_questionaire: true,
                tprm_risk_assesment: true
            });
        }

        setModal("Form Wizard modal");
    };

    const deleteCustomerOption = (_id) => {
        const self = this;
        $.confirm({
            title: "Are you sure?",
            content: "Do you really want to delete this customer?",
            type: "red",
            buttons: {
                ok: {
                    text: "Delete",
                    btnClass: "btn-danger",
                    keys: ["enter"],
                    action: function () {
                        deleteCustomerforest(id, _id, dispatch);
                    },
                },
                cancel: function () {
                },
            },
        });
    };

      const removeLogo = () => {
    setLogo("");
  };

    // Add this function to reset all form fields
    const resetFormFields = () => {
        // Reset all form fields to default values
        setIsEdit(false);
        setOrgName("");
        setOrgEmail("");
        setOrgContact("");
        setOrgContactName("");
        setWebsite("");
        setEmailAccess(false);
        setindustryType("");
        setDomain([]); // Reset domains array
        setAuthMethod("default");
        setServerType("");
        setLoginUrl("");
        setLogo("");
        setAddress("");
        setCountry("");
        setState("");
        setCity("");
        setLoginPage("");
        setKeyword([]);
        setCriticality("Medium");
        setTags([]);
        setTagInput("");
        setModuleLicenses({
            tprm_questionaire: true,
            tprm_risk_assesment: true
        });

        // Reset service fields
        setServiceName("");
        setServiceRegion("");

        // Reset profiling questions state
        setVendorProfiling([]);
        setCurrentQuestionIndex(0);
        setShowProfilingQuestions(false);
        setProfilingComplete(false);

        // Reset to first tab
        setCurrentStep(1);
    };

    // Function to close modal and reset form
    const closeAndResetModal = () => {
        // Reset all form fields to default values
        setIsEdit(false);
        setOrgName("");
        setOrgEmail("");
        setOrgContact("");
        setOrgContactName("");
        setWebsite("");
        setEmailAccess(false);
        setindustryType("");
        setDomain([]); // Reset domains array
        setAuthMethod("default");
        setServerType("");
        setLoginUrl("");
        setLogo("");
        setAddress("");
        setCountry("");
        setState("");
        setCity("");
        setLoginPage("");
        setKeyword([]);
        setCriticality("Medium");
        setTags([]);
        setTagInput("");
        
        // Reset domain conflict states
        setIsDomainInUse(false);
        setConflictingVendorId("0"); // Reset to '0'
        setBrandDetails(null);
        
        // Reset module licenses
        setModuleLicenses({
            tprm_questionaire: true,
            tprm_risk_assesment: true
        });

        // Reset service fields
        setServiceName("");
        setServiceRegion("");

        // Reset profiling questions state
        setVendorProfiling([]);
        setCurrentQuestionIndex(0);
        setShowProfilingQuestions(false);
        setProfilingComplete(false);
        setShowQuestionnaireForm(false);
        setServiceProfileData(null);
        setEmails([]);
        setEmailQuery("");

        // Reset to first tab
        setCurrentStep(1);
        
        // Reset the created vendor ID
        setCreatedVendorId(null);
        
        // Close the modal
        setModal("");
    };

    // Update the submitForm function to handle the different API calls based on domain existence
    const submitForm = async () => {
        // Form validation for basic vendor info (only if domain is not in use)
        const validationErrors = [];

        if (!isDomainInUse) {
            if (!orgName.trim()) {
                validationErrors.push("Organization name is required");
            }

            if (!industryType) {
                validationErrors.push("Industry type is required");
            }

            // Check that at least one module license is enabled
            if (!moduleLicenses.tprm_questionaire && !moduleLicenses.tprm_risk_assesment) {
                validationErrors.push("At least one module option must be selected");
            }
        }

        // Add validation for service name and region (required for both paths)
        if (currentStep === 2) {
            if (!serviceName.trim()) {
                validationErrors.push("Service name is required");
            }
            if (!serviceRegion.trim()) {
                validationErrors.push("Service region is required");
            }
        }

        // If there are any validation errors, show them and stop the form submission
        if (validationErrors.length > 0) {
            validationErrors.forEach(error => {
                toastr.error("Validation Error", error);
            });
            return false;
        }

        // Check if all profiling questions are answered
        if (currentStep === 2 && profilingQuestions.length > 0) {
            const unansweredQuestions = [];

            profilingQuestions.forEach((question, index) => {
                if (!vendorProfiling[index]?.response || vendorProfiling[index].response.trim() === '') {
                    unansweredQuestions.push(index + 1);
                }
            });

            if (unansweredQuestions.length > 0) {
                // Format the list of unanswered questions
                const unansweredList = unansweredQuestions.length > 3
                    ? `${unansweredQuestions.slice(0, 3).join(', ')} and ${unansweredQuestions.length - 3} more`
                    : unansweredQuestions.join(', ');

                toastr.error("Validation Error", `All vendor profiling questions are required. Please answer question${unansweredQuestions.length > 1 ? 's' : ''} ${unansweredList}.`);
                return false;
            }
        }

        try {
            let vendorId = createdVendorId || updateId;

            // Only create/update vendor if the domain is not already in use AND we don't have a createdVendorId
            if (!isDomainInUse && !createdVendorId) {
                // Create vendor data object (basic information only)
                const vendorData = {
                    orgName,
                    domains,
                    country,
                    keyWord,
                    industryType,
                    criticality,
                    tags,
                    orgContactName,
                    orgEmail,
                    orgContact,
                    address,
                    state,
                    city,
                    moduleLicenses: [
                        {
                            name: "tprm_questionaire",
                            enabled: moduleLicenses.tprm_questionaire
                        },
                        {
                            name: "tprm_risk_assesment",
                            enabled: moduleLicenses.tprm_risk_assesment
                        }
                    ],
                    // Include brand details if available
                    ...(brandDetails && {
                        description: brandDetails.description,
                        logoUrl: brandDetails.logoUrl
                    })
                };

                if (isEdit) {
                    // Update existing vendor
                    await updateCustomerforest(
                        vendorData,
                        id,
                        updateId,
                        dispatch
                    );
                    vendorId = updateId;
                } else {
                    // Create new vendor
                    const response = await createCustomerforestView(
                        vendorData,
                        id,
                        auth,
                        dispatch
                    );
                    // Extract vendor ID from responseVendor creation response:
                    if (response && response.data && response.data?.data?.forestViewClients[0]?._id) {
                        
                        vendorId = response.data?.data?.forestViewClients[0]?._id;
                    } else {
                        toastr.error("Error", "Failed to get vendor ID from creation response");
                        resetFormFields();
                        setModal("");
                        return;
                    }
                }
            } else if (isDomainInUse) {
                // If domain is in use, use the conflicting vendor ID
                vendorId = conflictingVendorId;
            }

            // Create service profile using the API endpoint
            if (currentStep === 2 && vendorId) {
                // Create service profile
                const serviceProfileData = {
                    serviceName,
                    serviceRegion,
                    vendorProfiling
                };

                try {
                    const session = localStorage.getItem("session");
                    
                    // Call the service profile API with the correct vendor ID
                    const response = await axios.post(
                        `${API_URL}/tprm/vendors/${vendorId}/service-profiles`,
                        serviceProfileData,
                        {
                            headers: {
                                Authorization: `Bearer ${session}`
                            }
                        }
                    );
                    
                    
                    if (response.data.error === false) {
                        // Store the service profile data
                        setServiceProfileData(response.data.data);
                        setShowQuestionnaireForm(true);
                        setCurrentStep(3); 
                        toastr.success("Success", "Service profile created successfully");
                        emailSuggestion(id, dispatch, isDomainInUse ? conflictingVendorId : createdVendorId, "");
                    } else {
                        toastr.error("Error", response.data.userMessage || "Failed to create service profile");
                    }
                } catch (error) {
                    // console.error removed
                    toastr.error("Error", error.response?.data?.userMessage || "Failed to create service profile");
                }
            }

            // Refresh the vendor list
            fetchCustomersforestView(id, dispatch, page, search, sortField, sortOrder, tagsFilter, criticalityFilter);

        } catch (error) {
            // console.error removed
            toastr.error("Error", "An error occurred while submitting the form");
        }
    };

    function capitalizeFirstLetter(string) {
        if (!string) return '';
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const setupScanSchedule = async (vendorId, vendorName) => {
        try {
            setModalVendorId(vendorId);
            setModalVendorName(vendorName);
            setScanScheduleLoading(true);

            // Get current scan schedule
            await getScanSchedule(id, dispatch, vendorId);

            // Once data is loaded, set initial values
            if (scanScheduleReduxData) {
                // Handle the flat structure format
                setAttackSurfaceScan(scanScheduleReduxData.attackSurface !== "no");
                setDarkWebScan(scanScheduleReduxData.dataExposure !== "no");

                setScanFrequency({
                    attackSurface: scanScheduleReduxData.attackSurface === "no" ? "daily" : scanScheduleReduxData.attackSurface,
                    darkWeb: scanScheduleReduxData.dataExposure === "no" ? "daily" : scanScheduleReduxData.dataExposure
                });
            } else {
                // Use default values if no data available
                setScanFrequency({
                    attackSurface: "daily",
                    darkWeb: "daily",
                });

                // Default to enabled
                setAttackSurfaceScan(true);
                setDarkWebScan(true);
            }

            // Set scheduling enabled
            setEnableSchedule(true);
        } catch (error) {
            // console.error removed
            // Use fallback default values
            setScanFrequency({
                attackSurface: "daily",
                darkWeb: "daily",
            });
            setAttackSurfaceScan(true);
            setDarkWebScan(true);
            setEnableSchedule(true);
        }

        // Open the schedule scan modal
        setIsScheduleScanModal(true);
    };

    const toggleDropdown = (id) => {
        if (id in dropdownRefs.current) {
            const keys = Object.keys(dropdownRefs.current);
            keys.forEach((key) => {
                if (key !== id && dropdownRefs.current[key] &&
                    dropdownRefs.current[key].querySelector &&
                    dropdownRefs.current[key].querySelector('.dropdown-menu')) {
                    const dropdownMenu = dropdownRefs.current[key].querySelector('.dropdown-menu');
                    if (dropdownMenu && dropdownMenu.classList.contains('show')) {
                        dropdownMenu.classList.remove('show');
                    }
                }
            });

            const dropdownMenu = dropdownRefs.current[id] &&
                dropdownRefs.current[id].querySelector &&
                dropdownRefs.current[id].querySelector('.dropdown-menu');

            if (dropdownMenu && dropdownMenu.classList.contains('show')) {
                dropdownMenu.classList.remove('show');
            } else if (dropdownMenu) {
                dropdownMenu.classList.add('show');
            }
        }
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRefs.current) {
                const keys = Object.keys(dropdownRefs.current);
                keys.forEach((key) => {
                    if (dropdownRefs.current[key] &&
                        typeof dropdownRefs.current[key].contains === 'function' &&
                        !dropdownRefs.current[key].contains(event.target)) {

                        const dropdownMenu = dropdownRefs.current[key].querySelector &&
                            dropdownRefs.current[key].querySelector('.dropdown-menu');

                        if (dropdownMenu && dropdownMenu.classList.contains('show')) {
                            dropdownMenu.classList.remove('show');
                        }
                    }
                });
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const viewCertificateModal = (id) => {
        // Call the viewCertificate API
        const orgId = localStorage.getItem("orgId");
        axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("session")}`;
        axios
            .get(`${API_URL}/risk-meta-data/${id}`)
            .then((response) => {
                if (response.data.error === false) {
                    const certificate = response.data.data;

                    // Format dates for display
                    const formatDateForDisplay = (dateString) => {
                        if (!dateString) return "";
                        try {
                            const date = new Date(dateString);
                            if (isValid(date)) {
                                return format(date, 'yyyy-MM-dd');
                            }
                        } catch (error) {
                            // console.error removed
                        }
                        return "";
                    };

                    // Extract filename from document_metadata if available
                    const extractFileName = (fileUrl, metadata) => {
                        if (metadata?.fileName) return metadata.fileName;
                        if (!fileUrl) return "";
                        // Split the URL by '/' and get the last part
                        const parts = fileUrl.split('/');
                        return parts[parts.length - 1];
                    };

                    setCertificateData({
                        name: certificate.name || "",
                        description: certificate.description || "",
                        type: certificate.type || "",
                        validating: certificate.validating || "",
                        policy: {
                            isExpired: certificate.policy?.isExpired || false,
                            expiryDate: formatDateForDisplay(certificate.policy?.expiryDate),
                            startDate: formatDateForDisplay(certificate.policy?.validFrom || certificate.policy?.startDate),
                            endDate: formatDateForDisplay(certificate.policy?.validTill || certificate.policy?.endDate),
                            noExpiry: certificate.policy?.noExpiry || false,
                            documentType: certificate.policy?.documentType || ""
                        },
                        fileUrl: certificate.fileUrl || certificate.document_metadata?.signedUrl || "",
                        fileName: extractFileName(certificate.fileUrl, certificate.document_metadata)
                    });

                    // Show the modal
                    setIsViewCertificateModal(true);

                    // Call the viewCertificate action to log the view (if needed)
                    // viewCertificate(id, dispatch, orgId);

                } else {
                    toastr.error("Error", response.data.userMessage);
                }
            }).catch((err) => {
                var message = "Some server error has occurred.";
                if (err.response) {
                    message = err.response.data.userMessage;
                }
                toastr.error("Error", message);
            });
    };

    const [isEditTagsModal, setIsEditTagsModal] = useState(false);
    const [editingVendorId, setEditingVendorId] = useState("");
    const [editingVendorName, setEditingVendorName] = useState("");
    const [editingTags, setEditingTags] = useState([]);
    const [newTagInput, setNewTagInput] = useState("");

    // Add this function after other functions
    const handleEditTags = (vendor) => {
        setEditingVendorId(vendor._id);
        setEditingVendorName(vendor.orgName);
        setEditingTags(vendor.tags || []);
        setNewTagInput("");
        setIsEditTagsModal(true);
    };

    const handleAddTag = () => {
        if (newTagInput.trim()) {
            setEditingTags([...editingTags, newTagInput.trim()]);
            setNewTagInput("");
        }
    };

    const handleRemoveTag = (tagToRemove) => {
        setEditingTags(editingTags.filter(tag => tag !== tagToRemove));
    };

    const handleUpdateTags = async () => {
        try {
            const session = localStorage.getItem("session");
            const response = await axios.put(
                `${API_URL}/organisation/${id}/sub-org/${editingVendorId}/manage-tags`,
                {
                    tags: editingTags
                },
                {
                    headers: {
                        Authorization: `Bearer ${session}`
                    }
                }
            );

            if (response.data.error === false) {
                toastr.success("Success", "Tags updated successfully");
                setIsEditTagsModal(false);
                // Refresh the vendor list
                fetchCustomersforestView(id, dispatch, page, search, sortField, sortOrder, tagsFilter, criticalityFilter);
            } else {
                toastr.error("Error", response.data.userMessage || "Failed to update tags");
            }
        } catch (error) {
            toastr.error("Error", error.response?.data?.userMessage || "Failed to update tags");
        }
    };

    // Add these state variables near the top of your component with other state variables


    const emailOptions = emailData?.data?.map((item) => (
        {
            value: item,
            label: item
        }
    ));
    // Add these helper functions for email handling
    const handleChangeEmail = (selected) => {
        if (!selected) {
            setEmailQuery(null); // Use null instead of empty string
            return;
        }

        // For react-select, keep the value as is (it's already in the correct format)
        setEmailQuery(selected);

        // Process the email for adding to the list
        if (selected.value) {
            // If it's an object with value property
            if (!emails.includes(selected.value)) {
                setEmails([...emails, selected.value]);
            }
        } else if (Array.isArray(selected) && selected.length > 0) {
            // Handle multiple selection case
            const newEmails = selected.filter(item => {
                // If it's a custom input (has __isNew__ property)
                if (item.__isNew__) {
                    return !emails.includes(item.value);
                }
                return !emails.includes(item.value);
            }).map(item => item.value);

            if (newEmails.length > 0) {
                setEmails([...emails, ...newEmails]);
                // Clear the selection after adding to the list
                setEmailQuery(null);
            }
        }
    };

    const addEmail = () => {
        if (!emailQuery) {
            // If the input is empty, do nothing
            return;
        }

        // Handle custom input (direct string input)
        if (typeof emailQuery === 'string') {
            const customEmail = emailQuery.trim();
            if (customEmail && !emails.includes(customEmail)) {
                setEmails([...emails, customEmail]);
                setEmailQuery('');
            }
            return;
        }

        // Handle react-select object
        if (emailQuery.value && !emails.includes(emailQuery.value)) {
            setEmails([...emails, emailQuery.value]);
            setEmailQuery(null);
        } else if (Array.isArray(emailQuery) && emailQuery.length > 0) {
            // Process each selected email
            const newEmails = emailQuery
                .filter(item => !emails.includes(item.value))
                .map(item => item.value);
            
            if (newEmails.length > 0) {
                setEmails([...emails, ...newEmails]);
            }
            setEmailQuery(null);
        }
    };

    const removeEmail = (index) => {
        const updatedEmails = [...emails];
        updatedEmails.splice(index, 1);
        setEmails(updatedEmails);
    };

    // Add this new state variable with your other state declarations
    const [createdVendorId, setCreatedVendorId] = useState(null);

    // Add this function if not already present
    const handleUpdateServiceProfile = async () => {
      try {
        const session = localStorage.getItem("session");
        // Use a fallback for vendorId
        const vendorId = createdVendorId || serviceProfileData.vendorId || serviceProfileData.vendor || updateId || conflictingVendorId;
        const response = await axios.put(
          `${API_URL}/tprm/vendors/${vendorId}/service-profiles/${serviceProfileData._id}/domains`,
          {
            domains: editingDomains,
            tier: editingTier
          },
          {
            headers: {
              Authorization: `Bearer ${session}`
            }
          }
        );

        if (response.data.error === false) {
          setServiceProfileData(response.data.data);
          setIsEditServiceProfileModal(false);
          toastr.success("Success", response.data.userMessage || "Service profile updated");
        } else {
          toastr.error("Error", response.data.userMessage || "Failed to update service profile");
        }
      } catch (error) {
        // console.error removed
        toastr.error("Error", error.response?.data?.userMessage || "Failed to update service profile");
      }
    };

    // Add this new function to check if service exists
    const checkServiceExists = async (name, region) => {
        if (!name || !region) return;
        
        // Get the vendor ID from various possible sources
        const vendorId = createdVendorId || updateId || conflictingVendorId;
        
        // If no vendor ID is available, show error and return
        if (!vendorId) {
            setServiceExists(false);
            setExistingServiceData(null);
            return;
        }
        
        setIsCheckingService(true);
        try {
            const session = localStorage.getItem("session");
            // Properly encode the parameters to handle spaces and special characters
            const encodedName = encodeURIComponent(name.trim());
            const encodedRegion = encodeURIComponent(region.trim());
            
            const response = await axios.get(
                `${API_URL}/organisations/${id}/tprm/vendors/${vendorId}/vendor-profiling/service-profile/check-exists?name=${encodedName}&region=${encodedRegion}`,
                {
                    headers: {
                        Authorization: `Bearer ${session}`
                    }
                }
            );
            
            if (response.data.error === false) {
                if (response.data?.userMessage === "Service profile exists") {
                    setServiceExists(true);
                    setExistingServiceData(response.data?.data?.serviceProfile);
                } else {
                    setExistingServiceData(null);
                }
            }
        } catch (error) {
            // console.error removed
            setServiceExists(false);
            setExistingServiceData(null);
        } finally {
            setIsCheckingService(false);
        }
    };

    // Update the debounced version to include conflictingVendorId in dependencies
    const debouncedCheckService = useCallback(
        debounce((name, region) => {
            checkServiceExists(name, region);
        }, 500),
        [id, createdVendorId, updateId, conflictingVendorId]
    );

    // Update the service name and region handlers
    const handleServiceNameChange = (e) => {
        const value = e.target.value;
        setServiceName(value);
        if (value && serviceRegion) {
            debouncedCheckService(value, serviceRegion);
        }
    };

    const handleServiceRegionChange = (e) => {
        const value = e.target.value;
        setServiceRegion(value);
        if (value && serviceName) {
            debouncedCheckService(serviceName, value);
        }
    };

    // Add download report function
    const handleDownloadReport = async (vendorId, vendorName) => {
        try {
            const session = localStorage.getItem("session");
            const response = await axios.get(
                `${API_URL}/tprm/organisation/${id}/vendor/${vendorId}/consolidated-risk-distribution/excel`,
                {
                    headers: {
                        Authorization: `Bearer ${session}`
                    },
                    responseType: 'blob'
                }
            );

            // Create download link
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            // const timestamp = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
            // const sanitizedVendorName = vendorName.replace(/[^a-zA-Z0-9\s-]/g, '').replace(/\s+/g, '_');
            link.setAttribute('download', `${vendorName} Report.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            // console.error removed
            toastr.error("Failed to download report. Please try again.");
        }
    };

    return (
        <div className="container-fluid risk-dashboard">
            <style>{sliderStyles}</style>
            <div className="block-header">
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                        <h1 className="welcome-text">Manage Vendor</h1>
                        <nav aria-label="breadcrumb" className="mt-1">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/tprm/vendor" className="welcome-textSmall">
                                        {window.location.pathname.includes('/forest-view') ? 'Forest View' : 'Third Party Risk Management'}
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active"
                                    aria-current="page">{window.location.pathname.includes('/forest-view') ? 'Company' : 'Vendor'} List
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <div className="d-flex justify-content-end col-md-12">
                            <input
                                type="file"
                                accept=".xls,.xlsx"
                                value={blank}
                                style={{ display: 'none' }}
                                onChange={handleFileSelect}
                                ref={fileInputRef}
                            />
                            {auth?.accessLevel !== "Threat Analyst" && (
                                <Link
                                    to={`${location.pathname}#add-vendor`}
                                    className="btn btn-trans btnVendor mx-2 d-flex align-items-center justify-content-center"
                                    style={{ color: "black", fontWeight: "bold" }}
                                    onClick={() => { setModal("Form Wizard modal"); }}
                                >
                                    + Add New {window.location.pathname.includes('/forest-view') ? 'Company' : 'Vendor'}
                                </Link>
                            )}
                            <button
                                type="button"
                                className="btn btn-primary smallButtonPrimary mr-1"
                                style={{ color: "black", fontWeight: "bold" }}
                                onClick={handleFileUpload}
                            >
                                Bulk Import
                            </button>
                            <a
                                type="button"
                                className="btn btn-primary excelButton smallButtonPrimary mr-1"
                                style={{ color: "black", fontWeight: "bold" }}
                                href={fileUrl}
                            >
                                Sample Excel
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="body">
                    <div className="row">
                        <div className="col-md-3">
                            <div class="searchBoxInput p-0 mr-2">
                                <input
                                    class="form-control form-control-sm ml-0 my-0"
                                    type="text"
                                    placeholder="Search"
                                    aria-label="Search"
                                    onChange={(r) => {
                                        setSearch(r.target.value);
                                        setPage(1);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div class="searchBoxInput p-0 mr-2">
                                <input
                                    class="form-control form-control-sm ml-0 my-0"
                                    type="text"
                                    placeholder="Tags Search"
                                    aria-label="Search"
                                    onChange={(r) => {
                                        setTagsFilter(r.target.value);
                                        setPage(1);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <select
                                className="custom-select custom-select-sm form-control form-control-sm"
                                onChange={(e) => {
                                    setCriticalityFilter(e.target.value);
                                    setPage(1);
                                }}
                            >
                                <option value="">Vendor Classification</option>
                                <option value="High">High</option>
                                <option value="Medium">Medium</option>
                                <option value="Low">Low</option>
                            </select>
                        </div>
                        <div className="col-sm-12">
                            <div className="table-responsive table-risk">
                                <table className="table mb-0">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>{window.location.pathname.includes('/forest-view') ? 'Company' : 'Vendor'} Name
                                                <FontAwesomeIcon icon={faSortUp} style={{ marginLeft: '5px', cursor: 'pointer' }}
                                                    onClick={() => { setSortField('orgAlpha'); setSortOrder('asc') }}
                                                />
                                                <FontAwesomeIcon icon={faSortDown} style={{ cursor: 'pointer' }}
                                                    onClick={() => { setSortField('orgAlpha'); setSortOrder('desc') }}
                                                />
                                            </th>
                                            <th>Vendor Classification</th>
                                            <th>Tags</th>
                                            <th>Attack surface Rating
                                                <FontAwesomeIcon icon={faSortUp} style={{ marginLeft: '5px', cursor: 'pointer' }}
                                                    onClick={() => { setSortField('attackSurfaceSecurityImpact'); setSortOrder('asc') }}
                                                />
                                                <FontAwesomeIcon icon={faSortDown} style={{ cursor: 'pointer' }}
                                                    onClick={() => { setSortField('attackSurfaceSecurityImpact'); setSortOrder('desc') }}
                                                />
                                            </th>
                                            <th>Dark Exposure Rating
                                                <FontAwesomeIcon icon={faSortUp} style={{ marginLeft: '5px', cursor: 'pointer' }}
                                                    onClick={() => { setSortField('darkWebSecurityImpact'); setSortOrder('asc') }}
                                                />
                                                <FontAwesomeIcon icon={faSortDown} style={{ cursor: 'pointer' }}
                                                    onClick={() => { setSortField('darkWebSecurityImpact'); setSortOrder('desc') }}
                                                />
                                            </th>
                                            <th>Overall Health Rating
                                                <FontAwesomeIcon icon={faSortUp} style={{ marginLeft: '5px', cursor: 'pointer' }}
                                                    onClick={() => { setSortField('totalImpact'); setSortOrder('asc') }}
                                                />
                                                <FontAwesomeIcon icon={faSortDown} style={{ cursor: 'pointer' }}
                                                    onClick={() => { setSortField('totalImpact'); setSortOrder('desc') }}
                                                />
                                            </th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* Check if there's an "Organization not found" error message from API */}
                                        {(forestViewList?.error === "Organization not found" || 
                                          forestViewList?.message === "Organization not found" ||
                                          forestViewList?.userMessage === "Organization not found" ||
                                          (typeof forestViewList === 'string' && forestViewList.includes("Organization not found"))) ? (
                                            <tr>
                                                <td colSpan="8" style={{ textAlign: 'center', padding: '50px 20px', color: '#dc3545', fontSize: '16px', fontWeight: '500' }}>
                                                    <i className="fa fa-exclamation-triangle" style={{ marginRight: '10px', fontSize: '18px' }}></i>
                                                    Organization not found
                                                </td>
                                            </tr>
                                        ) : currentTableDataForest && currentTableDataForest.length > 0 ? (
                                            currentTableDataForest.map((item, index) => {
                                                const pageCount = (page - 1) * 10 + 1;
                                                return (
                                                    <tr key={item._id || index}>
                                                        <td>
                                                            <span>{pageCount + index}</span>
                                                        </td>
                                                        <td>
                                                            <Link
                                                                title=""
                                                                style={{ color: "white" }}
                                                                to={`/tprm/vendor/${item?._id}`}
                                                            >
                                                                {capitalizeFirstLetter(item.orgName)}
                                                            </Link>
                                                            <p className="mb-0">{item.orgContactName}</p>
                                                        </td>
                                                    <td>
                                                        {item.criticality && (
                                                            <span className={`badge ${item.criticality === "High" ? "badge-danger" :
                                                                item.criticality === "Medium" ? "badge-warning" :
                                                                    item.criticality === "Low" ? "badge-success" : "badge-info"
                                                                }`}>
                                                                {item.criticality}
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {item.tags && item.tags.length > 0 ? (
                                                            <div className="d-flex flex-wrap gap-1 align-items-center">
                                                                <div className="d-flex flex-wrap gap-1">
                                                                    {item.tags.map((tag, idx) => (
                                                                        <span key={idx} className="badge badge-info mr-1 mb-1">{tag}</span>
                                                                    ))}
                                                                </div>
                                                                <span
                                                                    className="fa fa-pencil ml-2"
                                                                    style={{ cursor: "pointer", color: "#6563ff" }}
                                                                    onClick={() => handleEditTags(item)}
                                                                    title="Edit Tags"
                                                                ></span>
                                                            </div>
                                                        ) : (
                                                            <div className="d-flex align-items-center">
                                                                <span className="text-muted">No tags</span>
                                                                <span
                                                                    className="fa fa-pencil ml-2"
                                                                    style={{ cursor: "pointer", color: "#6563ff" }}
                                                                    onClick={() => handleEditTags(item)}
                                                                    title="Edit Tags"
                                                                ></span>
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {item?.rating?.attackSurfaceSecurityImpact} / 500
                                                    </td>
                                                    <td>
                                                        {item?.rating?.darkWebSecurityImpact} / 300
                                                    </td>
                                                    <td>
                                                        {
                                                            !isNaN(Number(item?.rating?.darkWebSecurityImpact) +
                                                                Number(item?.rating?.attackSurfaceSecurityImpact))
                                                                ? (Number(item?.rating?.darkWebSecurityImpact) +
                                                                    Number(item?.rating?.attackSurfaceSecurityImpact))?.toFixed(2)
                                                                : null
                                                            
                                                        } / 800                                                                    
                                                    </td>
                                                    <td>
                                                        {auth?.accessLevel !== "Threat Analyst" && (
                                                            <div className="d-flex align-items-center justify-content-center">
                                                                {/* Action buttons for vendor management - only visible to non-Threat Analyst users */}
                                                                <div className="action-buttons">
                                                                    {/* Edit button - Opens modal to modify vendor details */}
                                                                    <Link
                                                                        className="action-btn"
                                                                        to="#"
                                                                        onClick={() => {
                                                                            fetchCustomersById(item?._id, dispatch)
                                                                                .then((res) => {
                                                                                    editModal(res);
                                                                                })
                                                                                .catch((error) => {
                                                                                    toastr.error('Error fetching customer by ID:', error);
                                                                                });
                                                                        }}
                                                                        title="Edit Vendor Details"
                                                                        data-toggle="tooltip"
                                                                        data-placement="top"
                                                                    >
                                                                        <i className="fa fa-pencil"></i>
                                                                        <span className="action-label">Edit</span>
                                                                    </Link>
                                                                    
                                                                    {/* Users button - Navigate to vendor user management page */}
                                                                    <Link
                                                                        className="action-btn"
                                                                        to={`vendor/user/${item._id}`}
                                                                        title="Manage Vendor Users & Access"
                                                                        data-toggle="tooltip"
                                                                        data-placement="top"
                                                                    >
                                                                        <i className="fa fa-users"></i>
                                                                        <span className="action-label">Users</span>
                                                                    </Link>
                                                                    
                                                                    {/* Trust Panel button - View vendor risk assessment (only if questionnaire is enabled) */}
                                                                    {org.isVendorQuestionairreDisabled === false && (
                                                                    <Link
                                                                        className="action-btn"
                                                                        to={`/trust-panel/vendor/${item?._id}`}
                                                                        title="View Vendor Trust Assessment & Risk Profile"
                                                                        data-toggle="tooltip"
                                                                        data-placement="top"
                                                                    >
                                                                        <i className="fa fa-eye"></i>
                                                                        <span className="action-label">Trust Panel</span>
                                                                    </Link>
                                                                    )}
                                                                    
                                                                    {/* Delete button - Remove vendor from system (with confirmation) */}
                                                                    <Link
                                                                        className="action-btn text-danger"
                                                                        to="#"
                                                                        onClick={() => {
                                                                            deleteCustomerOption(item._id);
                                                                        }}
                                                                        title="Delete Vendor (This action cannot be undone)"
                                                                        data-toggle="tooltip"
                                                                        data-placement="top"
                                                                    >
                                                                        <i className="fa fa-trash"></i>
                                                                        <span className="action-label">Delete</span>
                                                                    </Link>
                                                                    
                                                                    {/* Rescan button - Trigger security assessment scan (only if questionnaire is enabled) */}
                                                                    {org.isVendorQuestionairreDisabled === false && (
                                                                    <Link
                                                                        className="action-btn text-info"
                                                                        to="#"
                                                                        onClick={() => {
                                                                            startScan(id, item._id, dispatch);
                                                                        }}
                                                                        title="Run Security Assessment Scan"
                                                                        data-toggle="tooltip"
                                                                        data-placement="top"
                                                                    >
                                                                        <i className="fa fa-refresh"></i>
                                                                        <span className="action-label">Rescan</span>
                                                                    </Link>
                                                                    )}
                                                                    
                                                                    {/* Download Report button - Export risk assessment data to Excel */}
                                                                    <Link
                                                                        className="action-btn text-success"
                                                                        to="#"
                                                                        onClick={() => handleDownloadReport(item._id, item.orgName)}
                                                                        title="Download Risk Assessment Report (Excel)"
                                                                        data-toggle="tooltip"
                                                                        data-placement="top"
                                                                    >
                                                                        <FontAwesomeIcon icon={faFileExcel} />
                                                                        <span className="action-label">&nbsp;Download Report</span>
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })
                                        ) : (
                                            <tr>
                                                <td colSpan="8" style={{ textAlign: 'center', padding: '50px 20px', color: '#6c757d', fontSize: '16px' }}>
                                                    <i className="fa fa-inbox" style={{ marginRight: '10px', fontSize: '18px' }}></i>
                                                    No vendors found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="dataTables_paginate">
                                {totalItemsSearch > 0 && (
                                    <Pagination
                                        className="pagination-bar"
                                        currentPage={page}
                                        totalCount={totalItemsSearch}
                                        pageSize={PageSize}
                                        onPageChange={(page) => setPage(page)}
                                    />
                                )}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div
                className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
                    }`}
            >
                <div className="modal-dialog modal-lg clientPageModal" id="clientModal">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{isEdit ? 'Edit Vendor' : 'Add New Vendor'}</h5>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={closeAndResetModal}
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body pricing_page">
                            <div className="col-xl-12 col-lg-12 col-md-12">
                                <div className="card">
                                    {/* Tab navigation */}
                                    <ul className="nav nav-tabs" role="tablist">
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${currentStep === 1 ? 'active' : ''}`}
                                                onClick={() => setCurrentStep(1)}
                                                href="#vendor-info"
                                                role="tab"
                                                data-toggle="tab"
                                            >
                                                Basic Information
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${currentStep === 2 ? 'active' : ''}`}
                                                onClick={() => setCurrentStep(2)}
                                                href="#vendor-profiling"
                                                role="tab"
                                                data-toggle="tab"
                                                style={{ pointerEvents: currentStep === 1 ? 'none' : 'auto' }}
                                            >
                                                Service Profiling
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${currentStep === 3 ? 'active' : ''}`}
                                                href="#questionnaire-form"
                                                role="tab"
                                                data-toggle="tab"
                                                style={{
                                                    pointerEvents: currentStep < 3 ? 'none' : 'auto',
                                                    display: showQuestionnaireForm ? 'block' : 'none'
                                                }}
                                            >
                                                Send Questionnaire
                                            </a>
                                        </li>
                                    </ul>

                                    {/* Tab content */}
                                    <div className="tab-content">
                                        {/* Basic Info Tab */}
                                        <div role="tabpanel" className={`tab-pane ${currentStep === 1 ? 'active' : ''}`} id="vendor-info">
                                            <div className="header">
                                                <h2 className="welcome-textSmall font18px">Basic Information</h2>
                                            </div>

                                            <div className="row clearfix">
                                                {/* Always show the core fields regardless of domain conflict */}
                                                {!isDomainInUse && (
                                                    <>
                                                        <div className="col-lg-6 col-md-12">
                                                            <div className="form-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Vendor Name *"
                                                                    value={orgName}
                                                                    onChange={(e) => setOrgName(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-6 col-md-12">
                                                            <div className="form-group position-relative">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Domains"
                                                                    name="domain"
                                                                    id="domain"
                                                                />
                                                                <i
                                                                    className="fa fa-plus iconPlusAbsoulte"
                                                                    onClick={() => handleClick("domain")}
                                                                    style={{ fontSize: "22px", color: "black" }}
                                                                ></i>
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-6 col-md-12">
                                                            <div className="form-group position-relative">
                                                                <select
                                                                    className="form-control"
                                                                    value={industryType}
                                                                    onChange={(e) => {
                                                                        setindustryType(e.target.value);
                                                                    }}
                                                                    disabled={industries.length === 0}
                                                                >
                                                                    <option value="" disabled>Select Industry Type</option>
                                                                    {industries.map((industry, index) => (
                                                                        <option key={index} value={industry}>
                                                                            {industry}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                {industries.length === 0 && (
                                                                    <div className="position-absolute" style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}>
                                                                        <div className="spinner-border spinner-border-sm text-primary" role="status">
                                                                            <span className="visually-hidden">Loading...</span>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {/* Show domain conflict message when domain is in use */}
                                                {isDomainInUse && (
                                                    <div className="col-lg-12 col-md-12">
                                                        <div className="alert alert-warning mt-2">
                                                            <i className="fa fa-exclamation-triangle mr-2"></i>
                                                            <strong>Domain already in use:</strong> This domain belongs to an existing vendor in the system.
                                                            You will skip basic information and proceed directly to service profiling.
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Only show brand details when domain is not in use */}
                                                {brandDetails && (
                                                    <div className="col-lg-12 col-md-12">
                                                        <div className="alert alert-info mt-2">
                                                            <div className="d-flex align-items-center mb-2">
                                                                {brandDetails.logoUrl && (
                                                                    <img
                                                                        src={brandDetails.logoUrl}
                                                                        alt={brandDetails.orgName}
                                                                        style={{
                                                                            width: '40px',
                                                                            height: '40px',
                                                                            objectFit: 'contain',
                                                                            marginRight: '10px',
                                                                            backgroundColor: 'white',
                                                                            padding: '5px',
                                                                            borderRadius: '4px'
                                                                        }}
                                                                    />
                                                                )}
                                                                <div>
                                                                    <strong className="d-block">{brandDetails.orgName}</strong>
                                                                    <small className="text-muted">{brandDetails.industry}</small>
                                                                </div>
                                                            </div>
                                                            <div className="mt-2">
                                                                <small className="d-block text-muted mb-1">Description:</small>
                                                                <small>{brandDetails.description}</small>
                                                            </div>
                                                            <div className="mt-2">
                                                                <small className="d-block text-muted mb-1">Address:</small>
                                                                <small>{brandDetails.address}</small>
                                                            </div>
                                                            <div className="mt-2">
                                                                <small className="text-success">
                                                                    <i className="fa fa-check-circle mr-1"></i>
                                                                    Brand details auto-filled
                                                                </small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Always show domains list even when domain is in use */}
                                                {domains && domains.length > 0 && (
                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="row">
                                                            {domains?.map((keyword, index) => (
                                                                <div className="col-md-4" key={index}>
                                                                    <label className="labelClientAdd">
                                                                        <span>
                                                                            {keyword}{" "}
                                                                            <span
                                                                                className="fa fa-times-circle"
                                                                                onClick={() => removeKeyword("domain", keyword)}
                                                                            ></span>
                                                                        </span>
                                                                    </label>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>


                                            {/* Only show additional fields if domain is NOT in use */}
                                            {!isDomainInUse && (
                                                <>
                                                    <div className="row clearfix">
                                                        <div className="col-lg-6 col-md-12">
                                                            {keyWord && keyWord.length > 0 && (
                                                                <div className="row">
                                                                    {keyWord.map((keyword, index) => (
                                                                        <div className="col-md-4" key={index}>
                                                                            <label className="labelClientAdd">
                                                                                <span>
                                                                                    {keyword}{" "}
                                                                                    <span
                                                                                        className="fa fa-times-circle"
                                                                                        onClick={() => removeKeyword("keyword", keyword)}
                                                                                    ></span>
                                                                                </span>
                                                                            </label>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="col-lg-6 col-md-12">
                                                            {logo && logo !== "" && (
                                                                <div className="col-lg-6 col-md-12">
                                                                    <div className="row">
                                                                        <img
                                                                            style={{ width: "100px" }}
                                                                            src={logo instanceof File ? URL.createObjectURL(logo) : `${IMAGE_URL}${logo}`}
                                                                            alt="Organization Logo"
                                                                        />
                                                                        <span
                                                                            className="fa fa-times-circle"
                                                                            style={{
                                                                                position: "absolute",
                                                                                marginTop: "-8px",
                                                                                marginLeft: "-8px",
                                                                                color: "red",
                                                                            }}
                                                                            onClick={() => removeLogo()}
                                                                        ></span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <hr />
                                                    <div>
                                                        <h6 className="mb-2">Module Access</h6>
                                                        <div className="row clearfix">
                                                            <div className="col-lg-12 col-md-12">
                                                                <div className="module-list">
                                                                    <div className="module-item d-flex align-items-center justify-content-between">
                                                                        <div className="module-name text-muted">Questionnaire</div>
                                                                        <div className="custom-control custom-switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="custom-control-input"
                                                                                id="moduleLicense1"
                                                                                checked={moduleLicenses.tprm_questionaire}
                                                                                onChange={(e) => setModuleLicenses({ ...moduleLicenses, tprm_questionaire: e.target.checked })}
                                                                            />
                                                                            <label className="custom-control-label" htmlFor="moduleLicense1"></label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="module-item d-flex align-items-center justify-content-between">
                                                                        <div className="module-name text-muted">Continuous Monitoring</div>
                                                                        <div className="custom-control custom-switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="custom-control-input"
                                                                                id="moduleLicense2"
                                                                                checked={moduleLicenses.tprm_risk_assesment}
                                                                                onChange={(e) => setModuleLicenses({ ...moduleLicenses, tprm_risk_assesment: e.target.checked })}
                                                                            />
                                                                            <label className="custom-control-label" htmlFor="moduleLicense2"></label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                            <hr />

                                            <div className="d-flex justify-content-end mt-4">
                                                {/* Modify the "Next" button handler */}
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={async () => {
                                                        // Check if domains exist first
                                                        if (!domains || domains.length === 0) {
                                                            toastr.error("Validation Error", "Please add at least one domain using the Add button before proceeding");
                                                            return;
                                                        }

                                                        if (isDomainInUse) {
                                                            // If domain exists, just move to step 2 without validation
                                                            // Initialize the profiling questions
                                                            if (vendorProfiling.length === 0) {
                                                                const initialProfiling = profilingQuestions.map((question, index) => ({
                                                                    _id: question._id,
                                                                    questionId: `question_${index}`,
                                                                    question: question.question || 'Unknown question',
                                                                    type: question.type,
                                                                    options: question.options || [],
                                                                    response: ''
                                                                }));
                                                                setVendorProfiling(initialProfiling);
                                                            }
                                                            setCurrentStep(2);
                                                        } else {
                                                            // Basic validation before proceeding
                                                            // Recheck domains just to be safe
                                                            if (!domains || domains.length === 0) {
                                                                toastr.error("Validation Error", "Please add at least one domain using the Add button before proceeding");
                                                                return;
                                                            }

                                                            if (!orgName.trim()) {
                                                                toastr.error("Error", "Organization name is required before proceeding");
                                                                return;
                                                            }
                                                            if (!industryType) {
                                                                toastr.error("Error", "Industry type is required before proceeding");
                                                                return;
                                                            }
                                                            
                                                            // Check that at least one module license is enabled
                                                            if (!moduleLicenses.tprm_questionaire && !moduleLicenses.tprm_risk_assesment) {
                                                                toastr.error("Error", "At least one module option must be selected");
                                                                return;
                                                            }
                                                            
                                                            try {
                                                                // Create vendor data object (basic information only)
                                                                const vendorData = {
                                                                    orgName,
                                                                    domains,
                                                                    country,
                                                                    keyWord,
                                                                    industryType,
                                                                    criticality,
                                                                    tags,
                                                                    orgContactName,
                                                                    orgEmail,
                                                                    orgContact,
                                                                    address,
                                                                    state,
                                                                    city,
                                                                    moduleLicenses: [
                                                                        {
                                                                            name: "tprm_questionaire",
                                                                            enabled: moduleLicenses.tprm_questionaire
                                                                        },
                                                                        {
                                                                            name: "tprm_risk_assesment",
                                                                            enabled: moduleLicenses.tprm_risk_assesment
                                                                        }
                                                                    ],
                                                                    // Include brand details if available
                                                                    ...(brandDetails && {
                                                                        description: brandDetails.description,
                                                                        logoUrl: brandDetails.logoUrl
                                                                    })
                                                                };

                                                                if (isEdit) {
                                                                    // Update existing vendor
                                                                    const response = await updateCustomerforest(
                                                                        vendorData,
                                                                        id,
                                                                        updateId,
                                                                        dispatch
                                                                    );
                                                                    setCreatedVendorId(updateId);
                                                                } else {
                                                                    // Create new vendor
                                                                    const response = await createCustomerforestView(
                                                                        vendorData,
                                                                        id,
                                                                        auth,
                                                                        dispatch
                                                                    );
                                                                    
                                                                    
                                                                    // Extract vendor ID from response
                                                                    if (response?.data?.forestViewClients[0]?._id) {
                                                                        setCreatedVendorId(response?.data?.forestViewClients[0]?._id);
                                                                        toastr.success("Success", "Vendor created successfully");
                                                                    } else {
                                                                        toastr.error("Error", "Failed to get vendor ID from creation response");
                                                                        return;
                                                                    }
                                                                }
                                                                
                                                                // Initialize the profiling questions
                                                                if (vendorProfiling.length === 0) {
                                                                    const initialProfiling = profilingQuestions.map((question, index) => ({
                                                                        questionId: `question_${index}`,
                                                                        question: question.question || 'Unknown question',
                                                                        type: question.type,
                                                                        options: question.options || [],
                                                                        response: ''
                                                                    }));
                                                                    setVendorProfiling(initialProfiling);
                                                                }
                                                                
                                                                // Move to step 2
                                                                setCurrentStep(2);
                                                            } catch (error) {
                                                                // console.error removed
                                                                toastr.error("Error", "Failed to create/update vendor");
                                                            }
                                                        }
                                                    }}
                                                >
                                                    Next
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-default ml-2"
                                                    onClick={closeAndResetModal}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>

                                        {/* Profiling Questions Tab */}
                                        <div role="tabpanel" className={`tab-pane ${currentStep === 2 ? 'active' : ''}`} id="vendor-profiling">
                                            <div className="header">
                                                <h2 className="welcome-textSmall font18px">Service Profiling</h2>
                                                <p className="text-muted mb-4">Please provide service details and complete the questionnaire to profile this vendor.</p>
                                            </div>

                                            {/* Add Service Name and Region fields */}
                                            <div className="row mb-4">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="serviceName">
                                                            Service Name 
                                                            {isCheckingService && <i className="fa fa-spinner fa-spin ml-2"></i>}
                                                        </label>
                                                        <div className="input-group">
                                                            <input
                                                                type="text"
                                                                className={`form-control ${serviceExists ? 'is-invalid' : ''}`}
                                                                id="serviceName"
                                                                placeholder="Enter service name"
                                                                value={serviceName}
                                                                onChange={handleServiceNameChange}
                                                                required
                                                            />
                                                            {serviceExists && (
                                                                <div className="input-group-append">
                                                                    <span className="input-group-text bg-danger text-white">
                                                                        <i className="fa fa-times"></i>
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {serviceExists && (
                                                            <div className="invalid-feedback d-block">
                                                                <div className="d-flex align-items-center mt-1">
                                                                    <i className="fa fa-exclamation-circle text-danger mr-2"></i>
                                                                    <span>This service name is already in use</span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="serviceRegion">
                                                            Service Region 
                                                            {isCheckingService && <i className="fa fa-spinner fa-spin ml-2"></i>}
                                                        </label>
                                                        <div className="input-group">
                                                            <input
                                                                type="text"
                                                                className={`form-control ${serviceExists ? 'is-invalid' : ''}`}
                                                                id="serviceRegion"
                                                                placeholder="Enter service region"
                                                                value={serviceRegion}
                                                                onChange={handleServiceRegionChange}
                                                                required
                                                            />
                                                            {serviceExists && (
                                                                <div className="input-group-append">
                                                                    <span className="input-group-text bg-danger text-white">
                                                                        <i className="fa fa-times"></i>
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {serviceExists && (
                                                            <div className="invalid-feedback d-block">
                                                                <div className="d-flex align-items-center mt-1">
                                                                    <i className="fa fa-exclamation-circle text-danger mr-2"></i>
                                                                    <span>This region is already in use</span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {serviceExists && existingServiceData && (
                                                <div className="alert alert-danger mb-4" style={{
                                                    borderRadius: '8px',
                                                    border: 'none',
                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                                    padding: '12px 16px',
                                                    backgroundColor: '#fff5f5',
                                                    borderLeft: '4px solid #dc3545'
                                                }}>
                                                    <div className="d-flex align-items-center">
                                                        <i className="fa fa-exclamation-circle text-danger mr-3" style={{ fontSize: '18px' }}></i>
                                                        <div>
                                                            <h6 className="mb-1" style={{ color: '#dc3545', fontWeight: '600' }}>Service Profile Already Exists</h6>
                                                            <p className="mb-0" style={{ color: '#666', fontSize: '14px' }}>
                                                                A service profile with the name "{existingServiceData.serviceName}" already exists in the region "{existingServiceData.serviceRegion}".
                                                                Please choose a different name or region to proceed.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Display all questions at once in a scrollable container */}
                                            <div className="profiling-questions-container p-3 border rounded mb-3" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                                {profilingQuestions.length === 0 ? (
                                                    <div className="text-center p-4">
                                                        <div className="spinner-border text-primary" role="status">
                                                            <span className="sr-only">Loading...</span>
                                                        </div>
                                                        <p className="mt-3">Loading questionnaire...</p>
                                                    </div>
                                                ) : (
                                                    profilingQuestions.map((question, index) => (
                                                        <div key={index} className="question-item mb-4 p-3 border-bottom">
                                                            <h6 className="font-weight-bold">
                                                                {index + 1}. {question.question}
                                                                <span className="text-danger ml-1">*</span>
                                                            </h6>

                                                            {question.type === 'text' && (
                                                                <div className="form-group mt-2">
                                                                    <textarea
                                                                        className={`form-control ${!vendorProfiling[index]?.response || vendorProfiling[index].response.trim() === '' ? 'border-danger' : ''}`}
                                                                        rows="3"
                                                                        placeholder="Enter your answer (required)"
                                                                        value={vendorProfiling[index]?.response || ''}
                                                                        onChange={(e) => {
                                                                            const updatedProfiling = [...vendorProfiling];
                                                                            updatedProfiling[index] = {
                                                                                questionId: `question_${index}`,
                                                                                question: question.question || 'Unknown question',
                                                                                type: question.type,
                                                                                response: e.target.value,
                                                                                options: question.options || []
                                                                            };
                                                                            setVendorProfiling(updatedProfiling);
                                                                        }}
                                                                    ></textarea>
                                                                    {!vendorProfiling[index]?.response || vendorProfiling[index].response.trim() === '' ?
                                                                        <small className="text-danger">This field is required</small> : null}
                                                                </div>
                                                            )}

                                                            {question.type === 'multiple_choice_single_select' && (
                                                                <div className="form-group mt-2">
                                                                    {question.options?.map((option, optionIndex) => (
                                                                        <div className="custom-control custom-radio custom-radio-vendor mb-2" key={optionIndex}>
                                                                            <input
                                                                                type="radio"
                                                                                id={`option-${index}-${optionIndex}`}
                                                                                name={`profiling-option-${index}`}
                                                                                className="custom-control-input"
                                                                                checked={vendorProfiling[index]?.response === option}
                                                                                onChange={() => {
                                                                                    const updatedProfiling = [...vendorProfiling];
                                                                                    updatedProfiling[index] = {
                                                                                        questionId: `question_${index}`,
                                                                                        question: question.question || 'Unknown question',
                                                                                        type: question.type,
                                                                                        options: question.options || [],
                                                                                        response: option
                                                                                    };
                                                                                    setVendorProfiling(updatedProfiling);
                                                                                }}
                                                                            />
                                                                            <label className="custom-control-label" htmlFor={`option-${index}-${optionIndex}`}>
                                                                                {option}
                                                                            </label>
                                                                        </div>
                                                                    ))}
                                                                    {!vendorProfiling[index]?.response || vendorProfiling[index].response.trim() === '' ?
                                                                        <small className="text-danger">Please select an option</small> : null}
                                                                </div>
                                                            )}
                                                        </div>
                                                    ))
                                                )}
                                            </div>

                                            {/* Progress indicator */}
                                            <div className="progress mb-3">
                                                <div
                                                    className="progress-bar"
                                                    role="progressbar"
                                                    style={{
                                                        width: `${(vendorProfiling.filter(item => item?.response && item.response.trim() !== '').length / profilingQuestions.length) * 100}%`
                                                    }}
                                                    aria-valuenow={vendorProfiling.filter(item => item?.response && item.response.trim() !== '').length}
                                                    aria-valuemin="0"
                                                    aria-valuemax={profilingQuestions.length}
                                                ></div>
                                            </div>
                                            <div className="text-center text-muted mb-4">
                                                {vendorProfiling.filter(item => item?.response && item.response.trim() !== '').length} of {profilingQuestions.length} questions answered
                                            </div>

                                            <div className="d-flex justify-content-between mt-4">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary"
                                                    onClick={() => setCurrentStep(1)}
                                                >
                                                    <i className="fa fa-arrow-left mr-1"></i> Back
                                                </button>
                                                <div>
                                                    { (
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary mr-2"
                                                            onClick={() => {
                                                                // Check if all questions are answered
                                                                const unansweredQuestions = [];

                                                                profilingQuestions.forEach((question, index) => {
                                                                    if (!vendorProfiling[index]?.response || vendorProfiling[index].response.trim() === '') {
                                                                        unansweredQuestions.push(index + 1);
                                                                    }
                                                                });

                                                                if (serviceName == "") {
                                                                    toastr.error("Validation Error", `Service name is required.`);
                                                                    return false;
                                                                }

                                                                if (serviceRegion == "") {
                                                                    toastr.error("Validation Error", `Service region is required.`);
                                                                    return false;
                                                                }

                                                                if (unansweredQuestions.length > 0) {
                                                                    // Format the list of unanswered questions
                                                                    const unansweredList = unansweredQuestions.length > 3
                                                                        ? `${unansweredQuestions.slice(0, 3).join(', ')} and ${unansweredQuestions.length - 3} more`
                                                                        : unansweredQuestions.join(', ');

                                                                    toastr.error("Validation Error", `All vendor profiling questions are required. Please answer question${unansweredQuestions.length > 1 ? 's' : ''} ${unansweredList}.`);

                                                                    // Scroll to the first unanswered question
                                                                    const firstUnansweredQuestion = document.getElementById(`option-${unansweredQuestions[0] - 1}-0`);
                                                                    if (firstUnansweredQuestion) {
                                                                        firstUnansweredQuestion.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                                                    }
                                                                    return;
                                                                }

                                                                submitForm();
                                                            }}
                                                        >
                                                            {isEdit ? 'Update' : 'Create'} Service Profile
                                                        </button>
                                                    )}
                                                    <button
                                                        type="button"
                                                        className="btn btn-default"
                                                        onClick={closeAndResetModal}
                                                    >
                                                        Close
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Questionnaire Tab */}
                                        <div role="tabpanel" className={`tab-pane ${currentStep === 3 ? 'active' : ''}`} id="questionnaire-form">
                                            <div className="header">
                                                <h2 className="welcome-textSmall font18px">Send Questionnaire</h2>
                                                <p className="text-muted mb-4">Send the questionnaire to vendor contacts.</p>
                                            </div>

                                            {serviceProfileData && (
                                                <>
                                                    {similarQuestionnaire && (
                                                        <div className="alert alert-warning mb-4" style={{
                                                            borderRadius: '12px',
                                                            border: 'none',
                                                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                            padding: '24px'
                                                        }}>
                                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                                <div className="d-flex align-items-center">
                                                                    <i className="fa fa-exclamation-triangle text-warning mr-3" style={{ fontSize: '24px' }}></i>
                                                                    <h5 className="mb-0" style={{ color: '#2c3e50', fontWeight: '600' }}>Similar Service Questionnaire has been sent to this vendor</h5>
                                                                </div>
                                                            </div>
                                                            <div className="row mb-3">
                                                                <div className="col-md-6">
                                                                    {similarQuestionnaire?.serviceProfile?.name && similarQuestionnaire?.serviceProfile?.region && (
                                                                        <div className="profile-info-item">
                                                                            <label style={{ color: '#6c757d', fontSize: '0.875rem', marginBottom: '4px' }}>Service Profile</label>
                                                                            <p style={{ color: '#2c3e50', fontSize: '1rem', margin: 0, fontWeight: '500' }}>
                                                                                {similarQuestionnaire?.serviceProfile?.name} ({similarQuestionnaire?.serviceProfile?.region})
                                                                            </p>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                
                                                                {!isNaN(similarQuestionnaire?.totalQuestions) && !isNaN(similarQuestionnaire?.autoFillableQuestionCount) && (
                                                                    <div className="col-md-6">
                                                                        <div className="profile-info-item">
                                                                            <label style={{ color: '#6c757d', fontSize: '0.875rem', marginBottom: '4px' }}>Questions</label>
                                                                            <p style={{ color: '#2c3e50', fontSize: '1rem', margin: 0, fontWeight: '500' }}>
                                                                                New Questions: {similarQuestionnaire?.totalQuestions - similarQuestionnaire?.autoFillableQuestionCount} | Auto-fillable: {similarQuestionnaire?.autoFillableQuestionCount}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                
                                                                <div className="col-md-6">
                                                                    <div className="profile-info-item">
                                                                        <label style={{ color: '#6c757d', fontSize: '0.875rem', marginBottom: '4px' }}> Current Status</label>
                                                                        <span className={`badge ${similarQuestionnaire?.status === "submitted" ? "badge-success" : 
                                                                            similarQuestionnaire?.status === "pending" ? "badge-warning" : "badge-info"}`} 
                                                                            style={{
                                                                                padding: '6px 12px',
                                                                                fontSize: '0.875rem',
                                                                                fontWeight: '500',
                                                                                borderRadius: '6px'
                                                                            }}>
                                                                            {similarQuestionnaire?.status}
                                                                        </span>
                                                                        <Link to={`/tprm/review-risk/${similarQuestionnaire?.questionFormId}`} className="btn btn-sm btn-outline-primary" target="_blank" rel="noopener noreferrer" style={{
                                                                            borderRadius: '6px',
                                                                            padding: '8px 16px',
                                                                            borderWidth: '1.5px',
                                                                            transition: 'all 0.2s'
                                                                        }}>View Assessment</Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="profile-info-item">
                                                                <label style={{ color: '#6c757d', fontSize: '0.875rem', marginBottom: '4px' }}>Sent Date</label>
                                                                <p style={{ color: '#2c3e50', fontSize: '1rem', margin: 0, fontWeight: '500' }}>
                                                                    {new Date(similarQuestionnaire?.createdAt).toLocaleDateString()}
                                                                </p>
                                                            </div>
                                                            <div className="mt-3">
                                                                <p className="text-muted mb-0">
                                                                    A similar questionnaire has already been sent to this vendor. You can proceed with sending a new one if needed.
                                                                </p>
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="alert alert-success" style={{
                                                        borderRadius: '12px',
                                                        border: 'none',
                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                        padding: '24px'
                                                    }}>
                                                        <div className="d-flex justify-content-between align-items-center mb-4">
                                                            <div className="d-flex align-items-center">
                                                                <i className="fa fa-check-circle text-success mr-3" style={{ fontSize: '24px' }}></i>
                                                                <h5 className="mb-0" style={{ color: '#2c3e50', fontWeight: '600' }}>Service Profile Created Successfully</h5>
                                                            </div>
                                                            <button
                                                                className="btn btn-sm btn-outline-primary"
                                                                style={{
                                                                    borderRadius: '6px',
                                                                    padding: '8px 16px',
                                                                    borderWidth: '1.5px',
                                                                    transition: 'all 0.2s'
                                                                }}
                                                                onClick={() => {
                                                                    setEditingDomains((serviceProfileData.domains || []).map(d => d.trim().toLowerCase()));
                                                                    setEditingTier(serviceProfileData.tier);
                                                                    setIsEditServiceProfileModal(true);
                                                                }}
                                                            >
                                                                <i className="fa fa-edit mr-2"></i> Edit
                                                            </button>
                                                        </div>
                                                        <div className="row mb-4">
                                                            <div className="col-md-6">
                                                                <div className="profile-info-item">
                                                                    <label style={{ color: '#6c757d', fontSize: '0.875rem', marginBottom: '4px' }}>Service Name</label>
                                                                    <p style={{ color: '#2c3e50', fontSize: '1rem', margin: 0, fontWeight: '500' }}>{serviceProfileData.name}</p>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="profile-info-item">
                                                                    <label style={{ color: '#6c757d', fontSize: '0.875rem', marginBottom: '4px' }}>Region</label>
                                                                    <p style={{ color: '#2c3e50', fontSize: '1rem', margin: 0, fontWeight: '500' }}>{serviceProfileData.region}</p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row mb-4">
                                                            <div className="col-md-6">
                                                                <div className="profile-info-item">
                                                                    <label style={{ color: '#6c757d', fontSize: '0.875rem', marginBottom: '4px' }}>Tier</label>
                                                                    <span className={`badge ${serviceProfileData.tier === "High" ? "badge-danger" :
                                                                        serviceProfileData.tier === "Medium" ? "badge-warning" : "badge-success"
                                                                        }`} style={{
                                                                            padding: '6px 12px',
                                                                            fontSize: '0.875rem',
                                                                            fontWeight: '500',
                                                                            borderRadius: '6px'
                                                                        }}>{serviceProfileData.tier}</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="mb-4">
                                                            <label style={{ color: '#6c757d', fontSize: '0.875rem', marginBottom: '8px', display: 'block' }}>Security Domains</label>
                                                            <div className="d-flex flex-wrap gap-2">
                                                                {serviceProfileData.domains.map((domain, index) => (
                                                                    <span key={index} className="badge badge-info" style={{
                                                                        padding: '6px 12px',
                                                                        fontSize: '0.875rem',
                                                                        fontWeight: '500',
                                                                        borderRadius: '6px',
                                                                        backgroundColor: '#e3f2fd',
                                                                        color: '#1976d2',
                                                                        border: '1px solid #bbdefb'
                                                                    }}>
                                                                        {domain.replace(/_/g, ' ')}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-4 g-3">
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label className="form-label" style={{ 
                                                                    color: '#2c3e50', 
                                                                    fontSize: '0.875rem',
                                                                    fontWeight: '500',
                                                                    marginBottom: '8px'
                                                                }}>Email Recipients</label>
                                                                <div className="d-flex selectBox">
                                                                    <div className="flex-grow-1">
                                                                        <CreatableSelect
                                                                            components={animatedComponents}
                                                                            options={emailOptions}
                                                                            isMulti
                                                                            isClearable
                                                                            value={emailQuery}
                                                                            onChange={handleChangeEmail}
                                                                            onInputChange={(inputValue) => {
                                                                                if (inputValue !== "") {
                                                                                    setEmailQuery(inputValue);
                                                                                }
                                                                            }}
                                                                            placeholder="Enter email address"
                                                                            formatCreateLabel={(inputValue) => `Add custom email: "${inputValue}"`}
                                                                            theme={(theme) => ({
                                                                                ...theme,
                                                                                colors: {
                                                                                    ...theme.colors,
                                                                                    primary: '#08283f',
                                                                                    primary25: '#2c2c2c',
                                                                                    primary50: '#353535',
                                                                                    neutral0: '#dadada',
                                                                                    neutral10: '#f0f0f0',
                                                                                    neutral20: '#d0d0d0',
                                                                                    neutral30: '#b3b3b3',
                                                                                    neutral40: '#cccccc',
                                                                                    neutral50: '#9e9e9e',
                                                                                    neutral60: '#b3b3b3',
                                                                                    neutral70: '#cccccc',
                                                                                    neutral80: '#e6e6e6',
                                                                                    neutral90: '#f2f2f2'
                                                                                }
                                                                            })}
                                                                            styles={{
                                                                                control: (base) => ({
                                                                                    ...base,
                                                                                    background: 'white',
                                                                                    borderColor: '#d0d0d0',
                                                                                    boxShadow: 'none',
                                                                                    borderRadius: '8px',
                                                                                    minHeight: '42px',
                                                                                    '&:hover': {
                                                                                        borderColor: '#08283f'
                                                                                    }
                                                                                }),
                                                                                menu: (base) => ({
                                                                                    ...base,
                                                                                    background: 'white',
                                                                                    border: '1px solid #d0d0d0',
                                                                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                                                                    zIndex: 100,
                                                                                    borderRadius: '8px'
                                                                                }),
                                                                                option: (base, state) => ({
                                                                                    ...base,
                                                                                    background: state.isSelected ? '#08283f' : state.isFocused ? '#f5f5f5' : 'white',
                                                                                    color: state.isSelected ? 'white' : '#333333',
                                                                                    '&:hover': {
                                                                                        background: state.isSelected ? '#08283f' : '#f5f5f5'
                                                                                    }
                                                                                }),
                                                                                multiValue: (base) => ({
                                                                                    ...base,
                                                                                    background: '#f0f0f0',
                                                                                    border: '1px solid #d0d0d0',
                                                                                    borderRadius: '6px'
                                                                                }),
                                                                                multiValueLabel: (base) => ({
                                                                                    ...base,
                                                                                    color: '#333333',
                                                                                    padding: '4px 8px'
                                                                                }),
                                                                                multiValueRemove: (base) => ({
                                                                                    ...base,
                                                                                    color: '#9e9e9e',
                                                                                    '&:hover': {
                                                                                        background: '#08283f',
                                                                                        color: 'white'
                                                                                    }
                                                                                }),
                                                                                input: (base) => ({
                                                                                    ...base,
                                                                                    color: '#333333'
                                                                                }),
                                                                                placeholder: (base) => ({
                                                                                    ...base,
                                                                                    color: '#666666'
                                                                                }),
                                                                                singleValue: (base) => ({
                                                                                    ...base,
                                                                                    color: '#333333'
                                                                                })
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary ms-2"
                                                                        style={{
                                                                            borderRadius: '8px',
                                                                            width: '42px',
                                                                            height: '42px',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            padding: 0
                                                                        }}
                                                                        onClick={() => {
                                                                            addEmail()
                                                                        }}
                                                                    >
                                                                        <i className="fa fa-plus"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="d-flex flex-wrap gap-2">
                                                                {emails?.map((email, index) => (
                                                                    <span key={index} className="emailBox" style={{
                                                                        background: '#f8f9fa',
                                                                        border: '1px solid #e9ecef',
                                                                        borderRadius: '6px',
                                                                        padding: '6px 12px',
                                                                        fontSize: '0.875rem',
                                                                        color: '#495057',
                                                                        display: 'inline-flex',
                                                                        alignItems: 'center',
                                                                        gap: '8px'
                                                                    }}>
                                                                        {email}
                                                                        <i
                                                                            className="fa fa-times-circle"
                                                                            style={{
                                                                                color: '#dc3545',
                                                                                cursor: 'pointer',
                                                                                fontSize: '0.875rem'
                                                                            }}
                                                                            onClick={() => removeEmail(index)}
                                                                        ></i>
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label className="form-label" style={{ 
                                                                    color: '#2c3e50', 
                                                                    fontSize: '0.875rem',
                                                                    fontWeight: '500',
                                                                    marginBottom: '8px'
                                                                }}>Due Date</label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    style={{
                                                                        borderRadius: '8px',
                                                                        border: '1px solid #d0d0d0',
                                                                        padding: '8px 12px',
                                                                        height: '42px'
                                                                    }}
                                                                    onChange={(e) => setDueDate(e.target.value)}
                                                                    placeholder="22/04/2024"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="d-flex justify-content-between mt-4">
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-secondary"
                                                            style={{
                                                                borderRadius: '8px',
                                                                padding: '8px 16px',
                                                                borderWidth: '1.5px',
                                                                transition: 'all 0.2s'
                                                            }}
                                                            onClick={() => setCurrentStep(2)}
                                                        >
                                                            <i className="fa fa-arrow-left mr-2"></i> Back
                                                        </button>
                                                        <div className="d-flex gap-2">
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                style={{
                                                                    borderRadius: '8px',
                                                                    padding: '8px 24px',
                                                                    transition: 'all 0.2s'
                                                                }}
                                                                onClick={sendQuestionnaire}
                                                            >
                                                                Send Questionnaire
                                                            </button>
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-default"
                                                                style={{
                                                                    borderRadius: '8px',
                                                                    padding: '8px 24px',
                                                                    transition: 'all 0.2s'
                                                                }}
                                                                onClick={closeAndResetModal}
                                                            >
                                                                Close
                                                            </button>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`modal fade Form-Wizard-modal ${isScheduleScanModal ? "d-block show" : ""}`}
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Schedule Scan</h5>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => setIsScheduleScanModal(false)}
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {scanScheduleLoading ? (
                                <div className="text-center p-4">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                    <p className="mt-3">Loading scan schedule data...</p>
                                </div>
                            ) : (
                                <div className="row clearfix">
                                    {modalVendorId && (
                                        <div className="col-lg-12 col-md-12 mb-3">
                                            <div className="alert alert-info">
                                                <strong>Note:</strong> You are scheduling scans for vendor: {modalVendorName}
                                            </div>
                                        </div>
                                    )}

                                    <div className="col-lg-12 col-md-12">
                                        <h5 className="mb-3">Configure Scan Schedule</h5>
                                        <div className="form-group" style={{
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            alignItems: "baseline"
                                        }}>
                                            <label style={{ marginRight: "10px", minWidth: "120px", fontWeight: "bold" }}>
                                                Attack Surface
                                            </label>
                                            <label style={labelClassStyle}>
                                                <input
                                                    checked={!attackSurfaceScan}
                                                    onChange={() => setAttackSurfaceScan(false)}
                                                    style={radioButtonStyle}
                                                    type="radio"
                                                    name="attackSurface"
                                                    value="no"
                                                />
                                                No Scan
                                            </label>
                                            <label style={labelClassStyle}>
                                                <input
                                                    checked={attackSurfaceScan && scanFrequency.attackSurface === "daily"}
                                                    onChange={() => {
                                                        setAttackSurfaceScan(true);
                                                        handleScanFrequencyChange("attackSurface", "daily");
                                                    }}
                                                    style={radioButtonStyle}
                                                    type="radio"
                                                    name="attackSurface"
                                                    value="daily"
                                                />
                                                Daily
                                            </label>
                                            <label style={labelClassStyle}>
                                                <input
                                                    checked={attackSurfaceScan && scanFrequency.attackSurface === "weekly"}
                                                    onChange={() => {
                                                        setAttackSurfaceScan(true);
                                                        handleScanFrequencyChange("attackSurface", "weekly");
                                                    }}
                                                    style={radioButtonStyle}
                                                    type="radio"
                                                    name="attackSurface"
                                                    value="weekly"
                                                />
                                                Weekly
                                            </label>
                                            <label style={labelClassStyle}>
                                                <input
                                                    checked={attackSurfaceScan && scanFrequency.attackSurface === "monthly"}
                                                    onChange={() => {
                                                        setAttackSurfaceScan(true);
                                                        handleScanFrequencyChange("attackSurface", "monthly");
                                                    }}
                                                    style={radioButtonStyle}
                                                    type="radio"
                                                    name="attackSurface"
                                                    value="monthly"
                                                />
                                                Monthly
                                            </label>
                                        </div>

                                        <div className="form-group mb-0" style={{
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            alignItems: "baseline"
                                        }}>
                                            <label style={{ marginRight: "10px", minWidth: "120px", fontWeight: "bold" }}>
                                                Dark Web
                                            </label>
                                            <label style={labelClassStyle}>
                                                <input
                                                    checked={!darkWebScan}
                                                    onChange={() => setDarkWebScan(false)}
                                                    style={radioButtonStyle}
                                                    type="radio"
                                                    name="darkWeb"
                                                    value="no"
                                                />
                                                No Scan
                                            </label>
                                            <label style={labelClassStyle}>
                                                <input
                                                    checked={darkWebScan && scanFrequency.darkWeb === "daily"}
                                                    onChange={() => {
                                                        setDarkWebScan(true);
                                                        handleScanFrequencyChange("darkWeb", "daily");
                                                    }}
                                                    style={radioButtonStyle}
                                                    type="radio"
                                                    name="darkWeb"
                                                    value="daily"
                                                />
                                                Daily
                                            </label>
                                            <label style={labelClassStyle}>
                                                <input
                                                    checked={darkWebScan && scanFrequency.darkWeb === "weekly"}
                                                    onChange={() => {
                                                        setDarkWebScan(true);
                                                        handleScanFrequencyChange("darkWeb", "weekly");
                                                    }}
                                                    style={radioButtonStyle}
                                                    type="radio"
                                                    name="darkWeb"
                                                    value="weekly"
                                                />
                                                Weekly
                                            </label>
                                            <label style={labelClassStyle}>
                                                <input
                                                    checked={darkWebScan && scanFrequency.darkWeb === "monthly"}
                                                    onChange={() => {
                                                        setDarkWebScan(true);
                                                        handleScanFrequencyChange("darkWeb", "monthly");
                                                    }}
                                                    style={radioButtonStyle}
                                                    type="radio"
                                                    name="darkWeb"
                                                    value="monthly"
                                                />
                                                Monthly
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={submitScanSchedule}
                                disabled={scanScheduleLoading}
                            >
                                {scanScheduleLoading ? 'Loading...' : 'Schedule Scan'}
                            </button>
                            <button
                                type="button"
                                className="btn btn-round btn-default"
                                onClick={() => setIsScheduleScanModal(false)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`modal fade ${isEditTagsModal ? "d-block show" : ""}`}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Edit Tags - {editingVendorName}</h5>
                            <button
                                type="button"
                                className="close"
                                onClick={() => setIsEditTagsModal(false)}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Current Tags</label>
                                <div className="d-flex flex-wrap gap-1 mb-3">
                                    {editingTags.map((tag, index) => (
                                        <span key={index} className="badge badge-info mr-1 mb-1">
                                            {tag}
                                            <span
                                                className="fa fa-times-circle ml-1"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => handleRemoveTag(tag)}
                                            ></span>
                                        </span>
                                    ))}
                                </div>
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Add new tag"
                                        value={newTagInput}
                                        onChange={(e) => setNewTagInput(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                handleAddTag();
                                            }
                                        }}
                                    />
                                    <div className="input-group-append">
                                        <button
                                            className="btn btn-primary"
                                            type="button"
                                            onClick={handleAddTag}
                                        >
                                            Add
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleUpdateTags}
                            >
                                Save Changes
                            </button>
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => setIsEditTagsModal(false)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {isEditServiceProfileModal && (
              <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <div style={{
                  background: '#fff',
                  borderRadius: 8,
                  minWidth: 320,
                  maxWidth: 420,
                  width: '90%',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                  padding: 0,
                  overflow: 'hidden'
                }}>
                  <div style={{
                    padding: '16px 20px',
                    borderBottom: '1px solid #eee',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}>
                    <span style={{ fontWeight: 600, fontSize: 18 }}>Edit Service Profile</span>
                    <button
                      onClick={() => setIsEditServiceProfileModal(false)}
                      style={{
                        background: 'none',
                        border: 'none',
                        fontSize: 24,
                        cursor: 'pointer',
                        color: '#888',
                        lineHeight: 1
                      }}
                      aria-label="Close"
                    >
                      &times;
                    </button>
                  </div>
                  <div style={{ padding: '20px', maxHeight: '60vh', overflowY: 'auto' }}>
                    <div style={{ marginBottom: 20 }}>
                      <label style={{ fontWeight: 600, marginBottom: 6, display: 'block' }}>Tier</label>
                      <select
                        value={editingTier}
                        onChange={e => setEditingTier(e.target.value)}
                        style={{
                          width: '100%',
                          padding: '7px 10px',
                          borderRadius: 5,
                          border: '1px solid #ccc',
                          fontSize: 15
                        }}
                      >
                        <option value="Low">Low</option>
                        <option value="Medium">Medium</option>
                        <option value="High">High</option>
                      </select>
                    </div>
                    <div>
                      <label style={{ fontWeight: 600, marginBottom: 6, display: 'block' }}>Security Domains</label>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        {availableDomains.map(domain => (
                          <label key={domain.key} style={{ display: 'flex', alignItems: 'center', fontSize: 15, fontWeight: 400, cursor: 'pointer', marginBottom: 2 }}>
                            <input
                              type="checkbox"
                              checked={editingDomains.includes(domain.key.toLowerCase())}
                              onChange={e => {
                                const normKey = domain.key.toLowerCase();
                                if (e.target.checked) {
                                  setEditingDomains([...editingDomains, normKey]);
                                } else {
                                  setEditingDomains(editingDomains.filter(d => d !== normKey));
                                }
                              }}
                              style={{ marginRight: 8 }}
                            />
                            {domain.label}
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div style={{
                    padding: '14px 20px',
                    borderTop: '1px solid #eee',
                    background: '#fafbfc',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 10
                  }}>
                    <button
                      onClick={() => setIsEditServiceProfileModal(false)}
                      style={{
                        background: '#6c757d',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 5,
                        padding: '7px 18px',
                        fontWeight: 500,
                        fontSize: 15,
                        cursor: 'pointer'
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleUpdateServiceProfile}
                      style={{
                        background: '#08283f',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 5,
                        padding: '7px 18px',
                        fontWeight: 500,
                        fontSize: 15,
                        cursor: 'pointer'
                      }}
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            )}
        </div>
    );
};

export default VendorRisk;

